<template>
  <div class="gx-od">
    <!-- <h1 class="gx-main__title">抖店订单</h1> -->

    <!-- 筛选栏 -->
    <div class="gx-od__filter custom-form-wrap">
      <el-form :inline="true" size="mini">
        <el-form-item label="下单平台：" v-show="false">
          <el-select class="w180" v-model="searchData.platform_type" placeholder="请选择" clearable filterable >
            <el-option v-for="item in platformTypeList" :key="item.val" :label="item.text" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺分组：">
          <el-select class="w180" v-model="searchData.group_ids" placeholder="全部分组" clearable multiple
                     collapse-tags filterable @change="setChange">
            <el-option v-for="item in groupList" :key="item.id" :label="item.name"
                       :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名：">
          <el-select class="w180" v-model="searchData.shop_id" placeholder="请选择" clearable>
            <el-option v-for="item in arrShop" :key="item.key" :label="item.key" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品信息：">
          <el-input class="w180" v-model="searchData.product_name" placeholder="请输入商品标题/商品ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="店铺订单号：">
          <el-input class="w180" v-model="searchData.dd_order_id" placeholder="请输入店铺订单号" clearable> </el-input>
        </el-form-item>
        <el-form-item label="采购订单号：">
          <el-input class="w180" v-model="searchData.pdd_order_id" placeholder="请输入采购订单号" clearable> </el-input>
        </el-form-item>
        <el-form-item label="采购备注：">
          <el-input class="w180" v-model="searchData.pdd_purchase_msg" placeholder="请输入采购备注" clearable> </el-input>
        </el-form-item>
        <el-form-item label="采购账号：">
          <el-input class="w180" v-model="searchData.pdd_account" placeholder="请输入采购账号" clearable></el-input>
        </el-form-item>
        <el-form-item label="采购快递单号：">
          <el-input class="w180" v-model="searchData.pdd_express_no" placeholder="请输入采购快递单号" clearable> </el-input>
        </el-form-item>
        <el-form-item label="买家退货单号：">
          <el-input class="w180" v-model="searchData.return_logistics_code" placeholder="请输入买家退货单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="平台退货单号：">
          <el-input class="w180" v-model="searchData.pdd_return_logistics_code" placeholder="请输入平台退货单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="问题订单：">
          <el-select class="w120" v-model="searchData.problem_types" multiple collapse-tags placeholder="请选择" clearable>
            <el-option v-for="item in arrProblemType" :key="item.val" :label="item.text" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联状态：">
          <el-select class="w120" v-model="searchData.link_status" placeholder="请选择" clearable>
            <el-option v-for="item in arrLinkStatus" :key="item.val" :label="item.text" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="抖店备注：">
          <el-input class="w180" v-model="searchData.seller_words" placeholder="请输入抖店备注" clearable></el-input>
        </el-form-item>
        <el-form-item label="旗帜颜色：">
          <el-select class="w180" v-model="searchData.seller_remark_stars" multiple collapse-tags placeholder="请选择" clearable>
            <el-option v-for="item in arrStar" :key="item.val" :label="item.text" :value="item.val">
              <span style="float: left">{{ item.text }}</span>
              <span style="float: right;"><i :class="item.icon" :style="[{color:item.color}]"></i></span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="留言备注：">
          <el-select class="w120" v-model="searchData.remark_filters" multiple collapse-tags placeholder="请选择" clearable>
            <el-option v-for="item in arrRemarkFilter" :key="item.val" :label="item.text" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实收金额：">
          <div class="gx-od__filter-range">
            <el-input v-model="searchData.receive_amount_min" placeholder="最小" clearable class="w80"></el-input>
            <span class="amount-sep">-</span>
            <el-input v-model="searchData.receive_amount_max" placeholder="最大" clearable class="w80"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="省份：">
          <el-select class="w180" v-model="searchData.province_ids" multiple collapse-tags placeholder="请选择" clearable filterable>
            <el-option v-for="item in arrProvince" :key="item.val" :label="item.text" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="多子订单：">
          <el-select class="w180" v-model="searchData.multi_child_order" multiple collapse-tags placeholder="请选择" clearable>
            <el-option v-for="item in arrChildOrderNumFilter" :key="'multi_' + item.val" :label="item.text" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合并采购：">
          <el-select class="w120" v-model="searchData.merge_purchase" placeholder="请选择" clearable>
            <el-option v-for="item in arrYesNoLayout" :key="'merge_' + item.val" :label="item.text" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="买家下单：">
          <el-date-picker class="w320"
                          v-model="searchData.create_time"
                          type="datetimerange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="买家下单开始日期"
                          end-placeholder="买家下单结束日期"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :picker-options="pickerOptions"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="采购下单：">
          <el-date-picker class="w320"
                          v-model="searchData.pdd_order_time"
                          type="datetimerange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="采购下单开始日期"
                          end-placeholder="采购下单结束日期"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :picker-options="pickerOptions"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="货损订单：">
          <el-select class="w180" v-model="searchData.damaged_filter" placeholder="请选择" clearable>
            <el-option v-for="item in arrDamagedFilter" :key="item.val" :label="item.text" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货损时间：">
          <el-date-picker class="w320"
                          v-model="searchData.damaged_time"
                          type="datetimerange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="货损开始时间"
                          end-placeholder="货损结束时间"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :picker-options="pickerOptions"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: auto">
          <button type="button" class="gx-od__filter-btn"  @click="doSearch()">查询</button>
          <button type="button" class="gx-od__filter-btn" @click="resetSearch()">重置</button></el-form-item>
      </el-form>
    </div>

    <!-- 列表面板：状态 tabs + 批量操作 + 表格 + 分页 -->
    <div class="gx-od__card">
    <!-- 状态 tabs -->
    <div class="gx-od__status-tabs">
      <button class="gx-od__status-tab" :class="{ 'gx-od__status-tab--on': !searchData.pdd_order_status }" @click="changeStatus('')">全部订单</button>
      <button
          v-for="s in arrPddStatus"
          :key="s.val"
          class="gx-od__status-tab"
          :class="{ 'gx-od__status-tab--on': searchData.pdd_order_status == s.val }"
          @click="changeStatus(s.val)"
      >{{ s.text }}<span v-if="s.num > 0" class="gx-od__status-num">{{ s.num }}</span></button>
    </div>

    <!-- 批量操作 -->
    <div class="gx-od__batch">
<!--      <label class="gx-od__checkall">
        <input type="checkbox" :checked="allChecked" @change="bindCheckAll($event.target.checked)" />
        <span class="gx-od__checkall-box">
        <svg v-if="allChecked" width="9" height="9" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
      </span>
        全选
      </label>-->
      <span class="gx-od__batch-label">共 {{ pageData.total }} 条</span>
      <button class="gx-od__btn gx-od__btn--danger" @click="bindBatDelete">批量删除</button>
      <button v-if="searchData.pdd_order_status == 100 || searchData.pdd_order_status == 102" class="gx-od__btn" @click="bindBatAlibabaPurchase">批量厂家直采</button>
      <button class="gx-od__btn" @click="bindBatCancelPurchase">批量取消</button>
      <button class="gx-od__btn" @click="orderExport">批量导出</button>
      <button v-if="searchData.pdd_order_status === 140" class="gx-od__btn" @click="setNotDeal">批量完结</button>
      <button class="gx-od__btn" :class="{ 'gx-od__btn--loading': sync_order_queue_count > 0 }" @click="openSyncDdOrderQueue" v-if="initialShopType===1">{{ sync_order_queue_count > 0 ? '正在同步' : '同步抖店订单' }}</button>
      <button v-if="searchData.pdd_order_status == 100 ||searchData.pdd_order_status == 101||searchData.pdd_order_status == 102" class="gx-od__btn" @click="openBatchAlibabaConnect">批量关联</button>
      <button class="gx-od__btn" @click="bindBatchMarkProblem">标记问题</button>
      <button class="gx-od__btn" @click="bindBatchMarkException">批量标记异常</button>
      <p v-if="isDamagedSearch" class="gx-od__damaged">货损总额：<span>¥{{ damaged_total_amount }}</span></p>
    </div>

    <div class="gx-table gx-od__table">
      <table>
        <thead>
          <tr>
            <th>
              <label >
                <input type="checkbox" :checked="allChecked" @change="bindCheckAll($event.target.checked)" />
                <span class="gx-od__check" :class="{ 'gx-od__check--on':allChecked}">
                  <svg v-if="allChecked" width="9" height="9" viewBox="0 0 8 8" fill="none">
                    <path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>

                </span>
              </label>
            </th>
            <th>
             货品信息<i class="el-icon-view text-gray" style="font-size: 14px;margin-left: 5px;" @click="showOrderInfo()"></i>
            </th>
            <th>售价/数量</th>
            <th>
               采购单详情
              <el-tooltip effect="dark" content="按每个1688采购单展示商品、SKU、运单及状态；修改关联请在右侧操作列" placement="top">
                <i class="el-icon-info text-gray" style="font-size: 14px;margin-left: 5px;"></i>
              </el-tooltip>
            </th>
            <th>订单状态</th>
            <th>金额</th>
            <th>退货信息</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in list" :key="item.id">
            <td class="td-middle">
              <span class="gx-od__check" :class="{ 'gx-od__check--on': checkList.includes(item.id) }" @click="toggleOne(item.id)">
                <svg v-if="checkList.includes(item.id)" width="8" height="8" viewBox="0 0 8 8" fill="none">
                  <path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </td>
            <!-- 货品信息 -->
            <td>
              <div class="gx-od__product">
                <!-- 单号信息 -->
                <div class="gx-od__info-lines">
                  <p v-if="item.dd_shop" class="gx-od__info-line">
                    <span class="gx-od__shop">{{ isHideOrderInfo ? '************' : item.dd_shop.shop_name }}</span>
                  </p>

                  <p class="gx-od__info-line" v-if="item.dd_order_id">
                    抖店单号：<span style="color: rgb(22, 119, 255);">{{ item.dd_order_id }}</span><i class="gx-od__copy" @click="bindCopy(item.dd_order_id)">⧉</i>
                  </p>

                  <p v-if="item.pdd_order && item.pdd_order.order_id" class="gx-od__info-line">
                    {{ item.pdd_order.buy_mode == 3 ? '巴巴' : '多多' }}单号：
                    <span :class="{ 'gx-od__order-id-link': isAlibabaPurchaseOrder(item.pdd_order) }" @click.stop="openAlibabaOrderDetail(item.pdd_order)">{{ item.pdd_order.order_id }}</span>
                    <a class="gx-od__order-more" href="javascript:;" @click.stop="openAlibabaOrderIdsDialog(item)" v-if="hasMultipleAlibabaOrders(item)">更多</a>
                    <i class="gx-od__copy" @click="bindCopy(item.pdd_order.order_id)" v-else>⧉</i>
                  </p>
                  <p v-if="!item.dd_shop" class="gx-od__info-line"><span class="gx-od__shop gx-od__shop--deleted">店铺已删除</span>：{{ item.dd_order_id }}<i class="gx-od__copy" @click="bindCopy(item.dd_order_id)">⧉</i></p>
                  <p v-if="item.shop_type == 0" class="gx-od__info-line">平台单号：{{ item.order_no }}<i class="gx-od__copy" @click="bindCopy(item.order_no)">⧉</i></p>
                  <p class="gx-od__info-line">下单时间：{{ item.create_time }}</p>
                  <p class="gx-od__info-line as-countdown" v-if="getAftersaleCountdownText(item)" @click.stop="goOrderAftersaleDetail(item)">
                    请在 <span class="as-countdown-num">{{ getAftersaleCountdownText(item) }}</span> 内处理，超时未处理将自动同意退款
                  </p>
                </div>

                <!-- 标记标签（右上角） -->
                <div class="gx-od__top-actions" v-if="item.is_exchange == 1 || (item.damaged_labels && item.damaged_labels.length)">
                  <div class="gx-od__flags">
                    <span v-if="item.is_exchange == 1 && item.dd_order_id.includes('B')" class="gx-od__flag-box" @click="showOriginalOrder(item.dd_order_id)">换货单</span>
                    <span v-if="item.is_exchange == 1 && !item.dd_order_id.includes('B')" class="gx-od__flag-box gx-od__flag-box--old" @click="showOriginalOrder(item.dd_order_id, 2)">换货原单</span>
                    <template v-if="item.damaged_labels && item.damaged_labels.length">
                <span
                    v-for="(label, dIdx) in item.damaged_labels"
                    :key="'dmg-' + dIdx"
                    class="gx-od__flag-box gx-od__flag-box--damaged"
                    :title="label === '合采货损' && item.damaged_detail ? damagedDetailText(item) : ''"
                >{{ label }}<span v-if="dIdx === item.damaged_labels.length - 1 && item.damaged_amount > 0" class="gx-od__damaged-amount"> ¥{{ item.damaged_amount }}</span></span>
                    </template>
                  </div>
                </div>

                <!-- 商品 -->
                <div class="gx-od__goods-info">
                  <span class="gx-od__thumb"><img v-if="item.product_pic" :src="item.product_pic" alt="" @click="openImg(item)" /><span v-else>🛍️</span></span>
                  <div class="gx-od__con-box">
                    <p class="gx-od__product-title">{{ isHideOrderInfo ? '************' : item.product_name }}</p>
                    <p class="gx-od__dim">{{ item.spec_value }}</p>
                    <p v-if="item.is_exchange == 1" class="gx-od__dim">换货规格：{{ item.exchange_product_spec_str }}</p>
                    <p class="gx-od__dim">
                      商品编码：{{ item.pdd_sku_id ?? item.pdd_code }}
                      <i class="gx-od__edit" @click="editProductCode(item, index)">✎</i>
                      <i class="gx-od__copy" @click="bindCopy('https://mobile.yangkeduo.com/goods.html?goods_id=' + (item.pdd_sku_id ?? item.pdd_code))">⧉</i>
                    </p>
                    <p class="gx-od__dim">商品ID：{{ item.goods_id ?? item.goods_id }}</p>
                    <p class="gx-od__dim">
                      <span>规格ID：{{ item.sku_id ?? item.sku_id }} <span class="query_permanent_link" @click="querySkuPermanentRelative(item)">查询是否永久关联</span></span>
                    </p>
                    <p v-if="item.supplier" class="gx-od__dim">供应商：{{ item.supplier.nickname }}</p>
                    <p v-if="item.deliver_ageing" class="gx-od__dim">发货时效：{{ item.deliver_ageing }}</p>
                    <p v-if="item.supplier_remark" class="gx-od__supplier" :title="item.supplier_remark">供应商备注：{{ item.supplier_remark }}</p>
                    <p v-if="item.abb_purchase_amount > 0 && searchData.pdd_order_status == 100" class="gx-od__stock"><span>直采价：{{ item.abb_purchase_amount ?? '0.00' }}</span></p>
                    <p v-if="item.ready_stock_amount > 0 && searchData.pdd_order_status == 100" class="gx-od__stock"><span>直发价：{{ item.ready_stock_amount ?? '0.00' }}</span></p>
                    <p v-if="item.pdd_order && item.pdd_order.order_id" class="gx-od__stock">
                      <span >采购价：<span style="color:rgb(212, 169, 70)">{{ getGoodsPurchaseCost(item).pay  }}</span></span>
                      <span v-if="item.pdd_order && item.pdd_order.order_id" style="margin-left: 12px;">毛利润：<span style="color:rgb(82, 196, 26)">{{ item.profit }}</span></span>
                      <span style="margin-left: 12px;">代发费：{{ getGoodsPurchaseCost(item).freight }}</span>
                    </p>
                    <p v-if="item.stock_msg" class="gx-od__red">{{ item.stock_msg }}</p>
                  </div>
                </div>

                <!-- 备注信息（采购备注/留言/采购快递/退货地址） -->
                <div class="gx-od__remark-box">
                  <p v-if="item.pdd_msg" class="gx-od__remark-line">
                    <span class="gx-od__remark-k gx-od__red">采购备注：</span>
                    <span class="gx-od__remark-val gx-od__red">{{ item.pdd_msg ?? '利润差太低' }}</span>
                  </p>
                  <p class="gx-od__remark-line">
                    <span class="gx-od__remark-k">买家留言：</span>
                    <span class="gx-od__remark-val">{{ item.buyer_words || '--' }}</span>
                  </p>
                  <p class="gx-od__remark-line">
                    <span class="gx-od__remark-k">商家留言：</span>
                    <span class="gx-od__remark-val">
                      <span>{{ item.order.seller_words || '--' }}</span>
                      <template v-for="(star, sIdx) in arrStar">
                        <i :key="sIdx" v-if="item.order.seller_remark_stars == star.val" class="gx-od__star" :class="star.icon" :style="{ color: star.color }"></i>
                      </template>
                      <i class="gx-od__edit" @click="showRemark(item.order_id)">✎</i>
                    </span>
                  </p>
                  <p v-if="item.pdd_order && item.pdd_order.express_no" class="gx-od__remark-line">
                    <span class="gx-od__remark-k">采购快递单号：</span>
                    <span class="gx-od__remark-val">{{ item.pdd_order.express_no }}</span>
                  </p>
                  <p v-if="item.pdd_order && item.pdd_order.return_logistics_code" class="gx-od__remark-line">
                    <span class="gx-od__remark-k">平台退货单号：</span>
                    <span class="gx-od__remark-val">{{ item.pdd_order.return_logistics_code }}</span>
                  </p>
                  <p v-if="item.pdd_order && item.pdd_order.return_logistics_code" class="gx-od__remark-line">
                    <span class="gx-od__remark-k">买家退货单号：</span>
                    <span class="gx-od__remark-val">{{ item.order_after_sales && item.order_after_sales.return_logistics_code }}</span>
                  </p>
                  <p v-if="item.pdd_order && item.pdd_order.pdd_return_address && item.pdd_order.pdd_return_address.id > 0" class="gx-od__remark-line">
                    <span class="gx-od__remark-k">退货地址：</span>
                    <span class="gx-od__remark-val">{{ item.pdd_order.pdd_return_address_encrypt }}
                  <i class="gx-od__refresh" @click="refreshReturnAddress(item)">⟳</i>
                  <i class="gx-od__edit" @click="editAddress(item.pdd_order.pdd_return_encrypt_address)">✎</i>
                </span>
                  </p>
                </div>
              </div>
            </td>
            <!-- 售价/数量 -->
            <td class="td-middle">
              <div class="gx-od__product-num area-col area-col-center">
                <p class="gx-od__strong">￥{{ item.pay_amount }}</p>
                <p class="gx-od__dim">x</p>
                <p class="gx-od__num">{{ item.item_num }}</p>
              </div>
            </td>
            <!--采购单详情 -->
            <td>
              <div class="gx-od__purchase">
                <!-- 按每个 1688 采购单展示；FE-B 布局调整；2026-08-17 -->
                <template v-if="getPurchaseGroups(item).length">
                  <div
                      v-for="(group, gidx) in getPurchaseGroups(item)"
                      :key="'pg-'+item.id+'-'+group.key+'-'+gidx"
                      class="purchase_order_block"
                      :class="{ 'is-fail': group.has_fail }"
                  >
                    <div class="purchase_order_head">
                      <span class="po_label">采购单{{ getPurchaseGroups(item).length > 1 ? (gidx + 1) : '' }}</span>
                      <span
                          v-if="group.alibaba_order_id"
                          class="po_order_id little-hand"
                          @click.stop="openAlibabaOrderById(group.alibaba_order_id)"
                      >{{ group.alibaba_order_id }}</span>
                      <span v-else class="po_order_id muted">未下单</span>
                      <!-- <span class="frozen_tag" v-if="group.is_frozen">已冻结</span> -->
                      <span class="line_status_tag" v-if="group.status_text" :class="'st-'+group.status_code"><span class="label">采购状态:</span>{{ group.status_text }}</span>
                    </div>
                    <div class="purchase_supplier" v-if="group.wangwang_account">
                      <span class="label">上家旺旺:</span>
                      <span class="name">{{ group.wangwang_account }}</span>
                      <i
                          class="el-icon-chat-dot-round purchase_icon"
                          @click.stop="openAlibabaWangwangChat(group.wangwang_account)"
                      ></i>
                    </div>
                    <!-- 组合/子行：每个采购单下的 SKU -->
                    <template v-if="group.lines && group.lines.length">
                      <div
                          v-for="(aline, aidx) in group.lines"
                          :key="'ai-'+item.id+'-'+aline.id+'-'+aidx"
                          class="purchase_product_card combo_item_card"
                          :class="{ 'is-fail': aline.line_status == 90 || aline.line_status == 100 }"
                      >
                        <div
                            class="card_img"
                            :class="{ 'is-link': aline.offer_id || aline.alibaba_goods_id }"
                            @click.stop="openAlibabaOfferDetail(aline.offer_id || aline.alibaba_goods_id)"
                        >
                          <img class="coverimg" :src="aline.product_img || ''" alt="">
                        </div>
                        <div class="card_body">
                          <p class="card_title_row">
                                  <span
                                      class="card_title"
                                      :class="{ 'is-link': aline.offer_id || aline.alibaba_goods_id }"
                                      @click.stop="openAlibabaOfferDetail(aline.offer_id || aline.alibaba_goods_id)"
                                  >{{ aline.product_name || aline.alibaba_goods_id || '-' }}</span>
                            <!-- <span class="line_status_tag" :class="'st-'+aline.line_status">{{ aline.line_status_text }}</span> -->
                          </p>
                          <p class="card_sku">SKU: {{ aline.sku_spec_value || aline.alibaba_sku_id || '-' }} × {{ aline.qty_unit || 1 }}（采 {{ aline.buy_num || 1 }}）</p>
                          <p class="card_fail_msg" v-if="aline.abb_purchase_msg">{{ aline.abb_purchase_msg }}</p>
                        </div>
                      </div>
                    </template>
                    <!-- 普通单：无子行时用直采关联卡片 -->
                    <div class="purchase_product_card" v-else-if="group.link">
                      <div
                          class="card_img"
                          :class="{ 'is-link': group.link.offer_id }"
                          @click.stop="openAlibabaOfferDetail(group.link.offer_id)"
                      >
                        <img class="coverimg" :src="group.link.product_img || ''" alt="">
                      </div>
                      <div class="card_body">
                        <p
                            class="card_title"
                            :class="{ 'is-link': group.link.offer_id }"
                            @click.stop="openAlibabaOfferDetail(group.link.offer_id)"
                        >{{ group.link.product_name || '-' }}</p>
                        <p class="card_sku">上家SKU: {{ group.link.sku_spec_value || '-' }}</p>
                        <p class="card_min">最低采购件数: {{ group.link.min_order_qty ?? 1 }}</p>
                      </div>
                    </div>
                    <div class="purchase_order_meta">
                      <div
                          v-if="group.account_text || canCancelPurchaseGroup(item, group)"
                          class="purchase_account_row"
                      >
                        <span class="account_text" v-if="group.account_text">采购账号：{{ group.account_text }}</span>
                        <span class="account_text" v-else></span>
                        <el-button
                            v-if="canCancelPurchaseGroup(item, group)"
                            type="danger"
                            plain
                            size="mini"
                            class="cancel_group_btn"
                            @click.stop="delPurchaseGroup(item, group)"
                        >取消该组采购</el-button>
                      </div>
                      <p v-if="hasPurchaseGroupAmount(group)">
                        采购金额：{{ formatMoney(group.pdd_pay_amount) }}
                        <span class="po_fee">运费：{{ formatMoney(group.shipping_fee) }}</span>
                        <span class="po_fee">合计：{{ formatMoney(group.total_amount) }}</span>
                      </p>
                      <p v-for="(tn, tidx) in (group.tracking_list || [])" :key="'tn-'+tidx">
                        运单：{{ tn.no }}<span v-if="tn.main">（主）</span>
                      </p>
                      <p v-if="group.express_no && !(group.tracking_list && group.tracking_list.length)">采购快递：{{ group.express_no }}</p>
                    </div>
                    <div class="purchase_footer is_linked">
                      <div
                          class="return_address_row"
                          :class="getPurchaseReturnAddressClass(item, group)"
                          @click="editAlibabaAddress(item, group)"
                      >
                        <div class="return_address_head">
                          <span class="return_label">退货地址</span>
                          <span class="return_status_tag">{{ getPurchaseReturnAddressLabel(item, group) }}</span>
                          <i
                              :class="Number(item.return_address_readonly) === 1 ? 'el-icon-view return_edit_icon' : 'el-icon-edit return_edit_icon'"
                          ></i>
                          <el-tooltip
                              v-if="getPurchaseReturnAddressState(item, group) <= 0"
                              effect="dark"
                              :content="getPurchaseReturnAddressError(item, group) || '未创建'"
                              placement="top"
                          >
                            <i class="el-icon-warning return_warn_icon"></i>
                          </el-tooltip>
                        </div>
                        <p
                            v-if="getPurchaseReturnAddressTime(item, group)"
                            class="return_time"
                        >{{ getPurchaseReturnAddressTime(item, group) }}</p>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="purchase_empty">暂无直采关联</div>
                  <div class="purchase_footer is_linked">
                    <div
                        class="return_address_row"
                        :class="getPurchaseReturnAddressClass(item)"
                        @click="editAlibabaAddress(item)"
                    >
                      <div class="return_address_head">
                        <span class="return_label">退货地址</span>
                        <span class="return_status_tag">{{ getPurchaseReturnAddressLabel(item) }}</span>
                        <i class="el-icon-edit return_edit_icon"></i>
                        <el-tooltip
                            v-if="item.return_address_state <= 0"
                            effect="dark"
                            :content="item.return_address_error || '未创建'"
                            placement="top"
                        >
                          <i class="el-icon-warning return_warn_icon"></i>
                        </el-tooltip>
                      </div>
                      <p
                          v-if="getPurchaseReturnAddressTime(item)"
                          class="return_time"
                      >{{ getPurchaseReturnAddressTime(item) }}</p>
                    </div>
                  </div>
                </template>
              </div>
            </td>
            <!--订单状态 -->
            <td>
              <div class="gx-od__product-sales">
                <div class="gx-od__st-row">
                  <span class="gx-od__st-label">抖店状态</span>
                  <span class="gx-od__st-badge" :class="'gx-od__st-badge--' + getStatusTone(item.order_status_text)">{{ item.order_status_text || '--' }}</span>
                </div>
                <div class="gx-od__st-row">
                  <span class="gx-od__st-label">采购状态</span>
                  <span class="gx-od__st-badge" :class="'gx-od__st-badge--' + getStatusTone(getPurchaseStatusText(item))">{{ getPurchaseStatusText(item) }}</span>
                </div>
                <p v-if="item.combo_type == 2">
                  <span class="combo_flag">组合商品</span>
                  <span v-if="item.alibaba_items_summary">（{{ item.alibaba_items_summary.success || 0 }}/{{ item.alibaba_items_summary.total || 0 }} 成功）</span>
                </p>
                <p class="red" v-if="item.pdd_status == 102 && item.abb_purchase_msg">{{ item.abb_purchase_msg }}</p>

                <p v-if="item.pdd_status == 120 && item.order_alibaba_order && item.order_alibaba_order.step_date > 0" class="gx-od__red">发货失败原因：{{ item.order_alibaba_order.step_remark || '未知错误' }}</p>
                <p v-if="item.pay_time > 0" class="gx-od__dim" style="color: rgb(153, 153, 153);">买家付款：{{ item.pay_time_str ?? '暂无' }}</p>
                <p v-if="item.pdd_order && item.pdd_order.order_time > 0" class="gx-od__dim" style="color: rgb(153, 153, 153);">采购下单：{{ item.pdd_order.order_time_str ?? '暂无' }}</p>
                <p v-if="item.order_alibaba_order && item.order_alibaba_order.show_send_time_row" class="gx-od__dim">
                  <span v-if="item.order_alibaba_order.send_time > 0">{{ item.order_alibaba_order.send_time_str ?? '暂无' }}</span>
                  <a v-else href="javascript:;" class="gx-od__link" @click="fetchAlibabaSendTime(item)">获取采购发货时间</a>
                </p>
                <p v-if="item.pdd_order && item.pdd_order.sync_time > 0" class="gx-od__dim">采购同步：{{ item.pdd_order.sync_time_str ?? '暂无' }}</p>
                <p v-if="item.order_status != 4" class="gx-od__buyer-info" @click="showAddressInfo(item.order_id)"><i class="el-icon-info"></i>买家信息</p>
              </div>
            </td>
            <!--金额 -->
            <td>
              <div class="gx-od__pay">
                <div class="gx-od__pay-row"><span class="gx-od-label">实付金额：</span> <span class="gx-od-price">￥{{ item.pay_amount }}</span> </div>
                <div class="gx-od__pay-row"><span class="gx-od-label">运费险：</span> <span class="gx-od-num">￥{{ item.post_insurance_amount }}</span> </div>
                <div class="gx-od__pay-row"><span class="gx-od-label">平台优惠：</span> <span class="gx-od-num">￥{{ item.promotion_platform_amount }}</span> </div>
                <div class="gx-od__pay-row"><span class="gx-od-label">精选联盟：</span> <span class="gx-od-num" :style="item.c_biz== 1 ?'color: rgb(82, 196, 26);' : ''">{{ item.c_biz == 1 ? '是' : '否' }}</span> </div>
              </div>
            </td>
            <!--退货信息 -->
            <td>
              <div class="gx-od__refund">
                <template v-if="item.order_after_sales">
                  <div class="gx-od__refund-row">退款金额：<span>￥{{ item.order_after_sales.refund_amount }}</span></div>
                  <div v-if="item.pdd_order && item.pdd_order.refund_status > 0" class="gx-od__refund-row">采购退款状态：<span>{{ item.pdd_order.refund_status_text }}</span></div>
                  <div v-if="item.pdd_order && item.pdd_order.return_logistics_code" class="gx-od__refund-row">平台退货运费：<span>{{ item.pdd_order.refund_freight }}</span></div>
                  <div v-if="item.lack_type" class="gx-od__red">{{ item.lack_type_text }}{{ item.lack_day > 0 ? (item.lack_day + '天') : '' }}</div>
                  <div v-if="item.order_after_sales" class="gx-od__red">{{ item.order_after_sales.text_part.aftersale_status_text }}</div>
                  <div v-if="item.order_after_sales" class="gx-od__red">{{ item.order_after_sales.text_part.aftersale_type_text }}</div>
                </template>
                <div v-else class="gx-od__dim">暂无退货信息</div>
              </div>
            </td>
            <!--操作 -->
            <td>
              <div class="gx-od__status area-col area-col-top">
                <div style="display: flex;align-items: center;">
                  <p><a href="javascript:;" style="margin-right: 5px;" class="gx-od__link gx-od__link--mark" :class="{ 'gx-od__link--warn': item.is_abnormal > 0 }" @click="bindMarkProblem(item)">标记问题</a></p>
                  <p><a href="javascript:;" class="gx-od__link gx-od__link--mark" :class="{ 'gx-od__link--danger': item.is_exception == 1 }" @click="bindMarkException(item)">{{ item.is_exception == 1 ? '取消异常' : '标记异常' }}</a></p>
                </div>
                <p v-if="canEditAlibabaDirectLink(item)">
                  <a href="javascript:;" class="gx-od__link" @click="alibabaCG(item)">{{ isAlibabaDirectLinked(item) ? '修改关联' : '厂家直采关联' }}</a>
                </p>
                <p v-if="item.can_manual_dd_deliver == 1"><a href="javascript:;" class="gx-od__link" @click="bindManualDdDeliver(item)">手动发货</a></p>
                <p v-if="item.can_edit_dd_deliver == 1"><a href="javascript:;" class="gx-od__link" @click="bindEditDdDeliver(item)">修改运单</a></p>
                <p v-if="canShowAlibabaPurchase(item)"><a href="javascript:;" class="gx-od__link details" @click="bindAlibabaPurchaseNew(item)">{{ item.pdd_status == 102 ? '重采失败组' : '厂家直采' }}</a></p>
                <p v-if="!item.pdd_order && !item.delete_time && item.ready_stock_amount && item.is_exception != 1"><a href="javascript:;" class="gx-od__link" @click="bindStockPurchase(item)">仓库直发</a></p>
                <p v-if="canShowCancelPurchaseUnpaid(item)"><a href="javascript:;" class="gx-od__link details" @click="delPurchase(item)">取消采购</a></p>
                <p v-if="item.pdd_order && item.pdd_order.order_id"><a href="javascript:;" class="gx-od__link" @click="needSyncOrder(item)">同步采购</a></p>
                <p><a href="javascript:;" class="gx-od__link" @click="afterSales(item)">同步抖店</a></p>
                <p v-if="item.pdd_order && item.pdd_order.is_deal == 1"><a href="javascript:;" class="gx-od__link">处理中</a></p>
                <p v-if="item.pdd_order && item.pdd_order.order_id && item.pdd_order.status != 90 && item.pdd_order.status != 105"><a href="javascript:;" class="gx-od__link">采购成功</a></p>
                <p v-if="item.pdd_order && item.pdd_order.order_id && item.pdd_order.status != 90 && item.pdd_order.status_name == '待支付'"><a href="javascript:;" class="gx-od__link" @click="toDoOrderPay(item)">去支付</a></p>
                <p v-if="canShowCancelPurchasePaid(item)"><a href="javascript:;" class="gx-od__link details" @click="repealPurchase(item)">取消采购</a></p>
                <p v-if="item.pdd_status == 140"><a href="javascript:;" class="gx-od__link" @click="setNotDeal(item.id)">完结</a></p>
                <p v-if="!item.pdd_order && !item.delete_time"><a href="javascript:;" class="gx-od__link" @click="postDeleteOrder(item.id)">删除</a></p>
                <p v-if="!item.pdd_order && item.delete_time > 0"><a href="javascript:;" class="gx-od__link" @click="cancelDelete(item)">恢复</a></p>
              </div>
            </td>
          </tr>
        <tr v-if="!list.length">
          <td :colspan="8">
            <div  class="gx-od__empty">暂无数据</div>
          </td>

        </tr>
        </tbody>
      </table>
    </div>

    <!-- 分页 -->
    <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
      <Pagination :total="pageData.total" :page.sync="pageData.page" :limit.sync="pageData.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getList(true, pageData.page)"  layout="total, sizes, prev, pager, next, jumper" />
    </div>
    </div>

    <!-- 弹窗（复用原版组件） -->
    <!-- 售后详情弹窗 -->
    <el-dialog title="售后详情" :visible.sync="dialog.aftersaleDialog" width="70%" class="custom-el-wrapper">
      <order-after-sales @close="dialog.aftersaleDialog = false" @complete="refresh()" :show.sync="dialog.aftersaleDialog" :info.sync="order_product" />
    </el-dialog>
    <!-- 删除订单二次确认 -->
    <el-dialog title="提示" :visible.sync="dialog.deleteOrderDialog"  width="420px" append-to-body :close-on-click-modal="false" @closed="onDeleteOrderDialogClosed" class="custom-el-wrapper" >
      <div class="delete-order-confirm">
        <p class="delete-order-confirm__tip">确认删除操作?</p>
        <el-input
            v-model="deleteConfirmText"
            placeholder="请输入确认删除"
            size="small"
            clearable
            @keyup.enter.native="confirmDeleteOrder"
        ></el-input>
        <p class="delete-order-confirm__hint">输入<span class="red">“确认删除”</span>后才能删除订单</p>
      </div>
      <span slot="footer" class="dialog-footer">
					<el-button size="small" @click="dialog.deleteOrderDialog = false">取消</el-button>
					<el-button
              type="primary"
              size="small"
              :disabled="deleteConfirmText !== '确认删除'"
              @click="confirmDeleteOrder"
          >确定</el-button>
				</span>
    </el-dialog>
    <!-- 组合采购：全部 1688 单号 -->
    <el-dialog
        title="1688采购单号"
        :visible.sync="dialog.alibabaOrderIdsDialog"
        width="480px"
        append-to-body
        @closed="alibabaOrderIdsDialogList = []"
        class="custom-el-wrapper"
    >
      <ul class="baba-order-ids-list">
        <li v-for="oid in alibabaOrderIdsDialogList" :key="oid">
          <span class="order-id-link" @click.stop="openAlibabaOrderById(oid)">{{ oid }}</span>
          <i class="iconfont icon-fuzhi" @click.stop="bindCopy(oid)"></i>
        </li>
      </ul>
    </el-dialog>
    <order-address @close="dialog.addressDialog = false" :show.sync="dialog.addressDialog" :order_id.sync="order_id" />
    <order-remark @close="dialog.remarkDialog = false" @complete="refresh()" :show.sync="dialog.remarkDialog" :order_id.sync="order_id" />
    <service-remark @close="dialog.remark2Dialog = false" @complete="refresh()" :show.sync="dialog.remark2Dialog" :order_id.sync="order_id" />
    <order-pay @close="dialog.payDialog = false" @success="$router.go(0)" :show.sync="dialog.payDialog" :order_id.sync="order_id" />
    <sync-order @close="dialog.syncOrderDialog = false" :show.sync="dialog.syncOrderDialog" />
    <pdd-account-confirm ref="pddAccountConfirm" :ali_order_type="ali_order_type" />
    <modify-confirm ref="modifyConfirm" @refresh="refresh" />
    <modify-confirm-order-no ref="modifyConfirmOrderNo" @refresh="refresh" />
    <modify-return-address ref="modifyReturnAddress" />
    <order-return-address ref="orderReturnAddress" @close="initFilterData(), getList()" />
    <connect-good ref="child" :data-arr="cg_data" />
    <alibaba-goods-connect ref="alibaba" :data-arr="cg_data" />
    <batch-alibaba-connect ref="batchAlibabaConnect" @refresh="onBatchAlibabaConnectRefresh" />
    <mark-problem-order ref="markProblemOrder" />
    <dd-deliver-dialog ref="ddDeliverDialog" />
    <sync-dd-order-queue ref="syncDdOrderQueue" :show.sync="dialog.syncDdOrderQueueDialog" @close="initFilterData(), dialog.syncDdOrderQueueDialog = false" />
    <gx-loading :show="loading" />
    <under-development ref="underDevelopmentRef"></under-development>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import gxLoading from '../../mixins/gxLoading'
import orderAddress from '../uc_orderNew/components/orderAddress/orderAddress.vue'
import orderRemark from '../uc_orderNew/components/orderRemark/orderRemark.vue'
import serviceRemark from '../uc_orderNew/components/serviceRemark/serviceRemark.vue'
import connectGood from '../uc_orderNew/components/connectGood/connectGood.vue'
import orderAfterSales from '../uc_orderNew/components/orderAfterSales/orderAfterSales.vue'
import orderPay from '../uc_orderNew/components/orderPay/orderPay.vue'
import syncOrder from '../uc_orderNew/components/syncOrder/syncOrder.vue'
import pddAccountConfirm from '../uc_orderNew/components/pdd_account_confirm/index.vue'
import modifyConfirm from '../uc_orderNew/components/modify_confirm/index.vue'
import modifyConfirmOrderNo from '../uc_orderNew/components/modify_confirm_order_no/index.vue'
import modifyReturnAddress from '../uc_orderNew/components/modify_return_address/index.vue'
import orderReturnAddress from '../uc_orderNew/components/order_return_address/index.vue'
import alibabaGoodsConnect from '../uc_orderNew/components/alibaba_goods_connect/index.vue'
import batchAlibabaConnect from '../uc_orderNew/components/batch_alibaba_connect/index.vue'
import markProblemOrder from '../uc_orderNew/components/mark_problem_order/index.vue'
import ddDeliverDialog from '../uc_orderNew/components/dd_deliver_dialog/index.vue'
import syncDdOrderQueue from '../uc_orderNew/components/sync_dd_order/index.vue'
import UnderDevelopment from "@/components/newUi/UnderDevelopment.vue";
import Pagination from "@/components/newUi/Pagination.vue";

export default {
  name: 'NewOrderListPage',
  components: {
     orderAddress, orderRemark, serviceRemark, connectGood, orderAfterSales, orderPay, syncOrder,
    pddAccountConfirm, modifyConfirm, modifyConfirmOrderNo, modifyReturnAddress, orderReturnAddress,
    alibabaGoodsConnect, batchAlibabaConnect, markProblemOrder, ddDeliverDialog, syncDdOrderQueue, GxLoading,UnderDevelopment,Pagination
  },
  mixins: [gxLoading],
  props:{
    initialShopType:{
      type:Number,
      default:1
    }
  },
  data() {
    return {
      order_id: 0,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      searchData: { shop_id: '', platform_type: '', link_status: '', merge_purchase: '', damaged_filter: '' },
      createTimeStart: '',
      createTimeEnd: '',
      pddOrderTimeStart: '',
      pddOrderTimeEnd: '',
      damagedTimeStart: '',
      damagedTimeEnd: '',
      arrStatus: [],
      arrStar: [],
      arrShop: [],
      arrAfterSales: [],
      arrProblemType: [],
      arrLinkStatus: [],
      arrRemarkFilter: [],
      arrYesNoLayout: [],
      arrChildOrderNumFilter: [],
      arrProvince: [],
      arrPddStatus: [],
      arrDamagedFilter: [],
      sync_order_queue_count: 0,
      checkAll: false,
      checkList: [],
      isLoading: false,
      list: [],
      pageData: { limit: 10, page: 1, total: 0 },
      pageSizeOptions: [10, 20, 50, 100, 200],
      total_partner_profit: 0,
      damaged_total_amount: 0,
      dialog: {
        addressDialog: false,
        aftersaleDialog: false,
        remarkDialog: false,
        remark2Dialog: false,
        payDialog: false,
        syncOrderDialog: false,
        syncDdOrderQueueDialog: false,
        deleteOrderDialog: false,
        alibabaOrderIdsDialog: false,
      },
      alibabaOrderIdsDialogList: [],
      deleteConfirmText: '',
      deleteConfirmIds: '',
      cg_data: '',
      order_product: {},
      is_decrypt: 0,
      decrypt_state: 1,
      decrypt_msg: '',
      isHideOrderInfo: false,
      ali_order_type: 0,
      platformTypeList: [
        { val: 1, text: '多多订单' },
        { val: 2, text: '巴巴订单' }
      ],
      firstLoad: true,
      groupList: [],
      nowTick: Date.now(),
      countdownTimer: null,
    }
  },
  computed: {
    ...mapState({
      users: (state) => state.login.userinfo
    }),
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    allChecked() {
      return this.list.length > 0 && this.checkList.length === this.list.length
    },
    isDamagedSearch() {
      return !!(this.searchData.damaged_filter || (this.searchData.damaged_time && this.searchData.damaged_time.length))
    },
    problemTypeOptions() {
      return (this.arrProblemType || []).map(s => ({ id: s.val, name: s.text }))
    },
    starOptions() {
      return (this.arrStar || []).map(s => ({ id: s.val, name: s.text }))
    },
    remarkFilterOptions() {
      return (this.arrRemarkFilter || []).map(s => ({ id: s.val, name: s.text }))
    },
    provinceOptions() {
      return (this.arrProvince || []).map(s => ({ id: s.val, name: s.text }))
    },
    childOrderNumOptions() {
      return (this.arrChildOrderNumFilter || []).map(s => ({ id: s.val, name: s.text }))
    }
  },
  watch:{
    initialShopType(){
     this.initData()
    }
  },
  mounted() {
    const isHideInfo = localStorage.getItem('isHideInfo')
    if (isHideInfo == 1) this.isHideOrderInfo = true
    this.countdownTimer = setInterval(() => {
      this.nowTick = Date.now()
    }, 1000)
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
    }
  },
  created() {
    const query = this.$route.query
    if (query.status) this.searchData.pdd_order_status = Number(query.status)
    if (query.after_sale) this.searchData.after_sale_status = Number(query.after_sale)
    if (query.damaged_filter) this.searchData.damaged_filter = query.damaged_filter
    if (query.damaged_time_start && query.damaged_time_end) {
      this.searchData.damaged_time = [query.damaged_time_start, query.damaged_time_end]
    }
   this.initData()
  },
  methods: {
    ...mapActions({
      getOrderManageList: 'ucenter_order/getOrderManageList',
      getOrderManageAddressInfo: 'ucenter_order/getOrderManageAddressInfo',
      getOrderManageDetail: 'ucenter_order/getOrderManageDetail',
      getOrderManageFilterData: 'ucenter_order/getOrderManageFilterData',
      opOrderManageBatPurchase: 'ucenter_order/opOrderManageBatPurchase',
      opOrderManageCheckAliOrderType: 'ucenter_order/opOrderManageCheckAliOrderType',
      opOrderManageBatAbnormal: 'ucenter_order/opOrderManageBatAbnormal',
      opOrderManageBatchMarkException: 'ucenter_order/opOrderManageBatchMarkException',
      opOrderManageReceipt: 'ucenter_order/opOrderManageReceipt',
      opDdShopRefreshDecrypt: 'ucenter_order/opDdShopRefreshDecrypt',
      opUnDecrypt: 'ucenter_order/opUnDecrypt',
      opReDecrypt: 'ucenter_order/opReDecrypt',
      opOrderManageDeleteProduct: 'ucenter_order/opOrderManageDeleteProduct',
      opOrderManageDelPddOrder: 'ucenter_order/opOrderManageDelPddOrder',
      opOrderManageSendGiftOrder: 'ucenter_order/opOrderManageSendGiftOrder',
      opOrderManageSetNotDealOrder: 'ucenter_order/opOrderManageSetNotDealOrder',
      opOrderManageRepealPurchase: 'ucenter_order/opOrderManageRepealPurchase',
      opOrderManageNeedSyncPddOrder: 'ucenter_order/opOrderManageNeedSyncPddOrder',
      opOrderManageFetchAlibabaSendTime: 'ucenter_order/opOrderManageFetchAlibabaSendTime',
      opOrderManageUpdateOrderAfterSale: 'ucenter_order/opOrderManageUpdateOrderAfterSale',
      opOrderManageCancelDelete: 'ucenter_order/opOrderManageCancelDelete',
      opRefreshReturnAddress: 'ucenter_order/opRefreshReturnAddress',
      opSetSellerWords: 'ucenter_order/opSetSellerWords',
      opUpdatePddAccount: 'ucenter_order/opUpdatePddAccount',
      opUpdatePddOrderNo: 'ucenter_order/opUpdatePddOrderNo',
      opUpdateOrderProduct: 'ucenter_order/opUpdateOrderProduct',
      opUpdateBuyMode: 'ucenter_order/opUpdateBuyMode',
      opSetPddReturnAddress: 'ucenter_order/opSetPddReturnAddress',
      opSetAutoSendGift: 'ucenter_order/opSetAutoSendGift',
      opDoOrderPay: 'ucenter_order/opDoOrderPay',
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList',
      GetQuerySkuRelativeInfo: "ucenter_order/GetQuerySkuRelativeInfo",
    }),
    initData(){
      this.list =  []
      this.pageData.page =  1
      this.pageData.total =  0
      this.groupList=[]
      this.arrPddStatus=[]
      if(this.initialShopType===7){
        this.$nextTick(()=>{
          this.$refs.underDevelopmentRef.show()
        })
        return
      }
      this.getList()
      this.loadGroupList()
    },

    loadGroupList() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    setChange() {
      if (this.$store.state.login.user_level == 9 && this.searchData.group_ids && this.searchData.group_ids.length) {
        this.searchData.group_ids = []
        this.$message.error('普通会员无法使用分组')
      }
    },
    initFilterData() {
      this.getOrderManageFilterData({
        data: this.searchData,
        success: (res) => {
          if (res.code === 200) {
            this.arrStatus = res.data.arr_status || []
            this.arrStar = res.data.arr_star || []
            this.arrAbnormal = res.data.arr_abnormal || []
            this.arrProblemType = res.data.arr_problem_type || []
            this.arrLinkStatus = res.data.arr_link_status || []
            this.arrRemarkFilter = res.data.arr_remark_filter || []
            this.arrYesNoLayout = res.data.arr_yes_no_layout || []
            this.arrChildOrderNumFilter = res.data.arr_child_order_num_filter || []
            this.arrProvince = res.data.arr_province || []
            this.arrAfterSales = res.data.arr_after_sales || []
            this.arrShop = res.data.arr_shop || []
            this.shopTypeList = res.data.shop_types || []
            this.arrPddStatus = res.data.arr_pdd_status || []
            this.arrDamagedFilter = res.data.arr_damaged_filter || []
            this.sync_order_queue_count = res.data.sync_order_queue_count || 0
            if (this.firstLoad) {
              this.firstLoad = false
              for (let i = 0; i < this.arrPddStatus.length; i++) {
                if (this.arrPddStatus[i].val == 122 && this.arrPddStatus[i].num > 0) {
                  this.$alert('获取退货地址失败订单数：' + this.arrPddStatus[i].num, '提示', {
                    confirmButtonText: '查看',
                    cancelButtonText: '取消',
                    center: true,
                    showCancelButton: true,
                    type: 'warning',
                    callback: (action) => {
                      if (action === 'confirm') this.changeStatus(122)
                    }
                  })
                }
              }
            }
          }
        }
      })
    },
    buildListParam(extra = {}) {
      const param = { limit: this.pageData.limit, page: this.pageData.page }
      if (Array.isArray(this.searchData.group_ids) && this.searchData.group_ids.length === 0) param.group_ids = ''
      else if (!this.searchData.group_ids) param.group_ids = ''
      Object.assign(param, this.searchData, extra)
      ;['problem_types', 'seller_remark_stars', 'remark_filters', 'province_ids', 'multi_child_order'].forEach((key) => {
        if (Array.isArray(param[key])) {
          if (param[key].length) param[key] = param[key].join(',')
          else delete param[key]
        }
      })
      return param
    },
    resetSearch() {
      this.searchData = { shop_id: '', platform_type: '', link_status: '', merge_purchase: '', damaged_filter: '' }
      this.createTimeStart = ''
      this.createTimeEnd = ''
      this.pddOrderTimeStart = ''
      this.pddOrderTimeEnd = ''
      this.damagedTimeStart = ''
      this.damagedTimeEnd = ''
      this.checkList = []
      this.getList()
    },
    refresh() {
      this.pageData.page = 1
      this.checkList = []
      this.getList()
    },
    changeStatus(val) {
      this.searchData.pdd_order_status = val
      this.refresh()
    },
    doSearch() {
      this.pageData.page = 1
      this.checkList = []
      this.getList()
    },
    syncTime(key, start, end) {
      if (start && end) {
        this.searchData[key] = [start.replace('T', ' '), end.replace('T', ' ')]
      } else {
        delete this.searchData[key]
      }
    },
    onPageSizeChange(size) {
      this.pageData.limit = size
      this.pageData.page = 1
      this.getList(true, 1)
    },
    getList(showLoading, page, onDone) {
      if(this.initialShopType===7) return;
      if (page) this.pageData.page = page
      const param = this.buildListParam()
      this.loadingStart()
      this.getOrderManageList({
        data: param,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.list = res.data.data || []
            this.pageData.total = res.data.total || 0
            this.is_decrypt = res.data.is_decrypt
            this.decrypt_state = res.data.decrypt_state
            this.decrypt_msg = res.data.decrypt_msg
            this.total_partner_profit = res.data.total_partner_profit
            this.damaged_total_amount = res.data.damaged_total_amount || 0
            this.initFilterData()
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
          if (typeof onDone === 'function') this.$nextTick(onDone)
        }
      })
    },
    toggleOne(id) {
      const idx = this.checkList.indexOf(id)
      if (idx > -1) this.checkList.splice(idx, 1)
      else this.checkList.push(id)
    },
    bindCheckAll(val) {
      this.checkList = val ? this.list.map(i => i.id) : []
    },
    bindCopy(text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      document.body.removeChild(input)
      this.$message({ message: '复制成功', type: 'success' })
    },
    showAddressInfo(id) {
      this.order_id = id
      this.dialog.addressDialog = true
    },
    showOrderInfo() {
      const isHideInfo = localStorage.getItem('isHideInfo')
      if (isHideInfo == 1) {
        localStorage.setItem('isHideInfo', 0)
        this.isHideOrderInfo = false
      } else {
        localStorage.setItem('isHideInfo', 1)
        this.isHideOrderInfo = true
      }
    },
    showRemark(id) {
      this.order_id = id
      this.dialog.remarkDialog = true
    },
    showAfterSaleInfo(order_product) {
      this.order_product = order_product
      this.dialog.aftersaleDialog = true
    },
    openImg(row) {
      const htm = '<img style="object-fit: cover;margin-right: 10px;max-height:70vh;" src="' + row.product_pic + '" alt="">' +
          '<div style="margin-top:10px;font-size:16px;">' + row.spec_value + '</div>' +
          '<div style="margin-top:5px;font-size:16px;">实付:￥' + row.pay_amount + '</div>'
      this.$alert(htm, row.product_name, {
        dangerouslyUseHTMLString: true,
        showClose: false,
        confirmButtonText: '关闭',
        closeOnClickModal: true,
        customClass: 'zdy-message-box'
      })
    },
    damagedDetailText(item) {
      const d = item.damaged_detail
      if (!d) return ''
      let txt = (d.items || []).map(r => `${r.spec}，单价${r.unit_price}，小计${r.subtotal}`).join('\n')
      txt += `\n运费：${d.shipping_fee}\n合计：${d.purchase_total}（抖店${d.dd_total}）`
      return txt
    },
    /* ── 问题/异常 ── */
    bindMarkProblem(item) {
      this.$refs.markProblemOrder.open(item, this.arrProblemType, () => { this.refresh() })
    },
    bindBatchMarkProblem() {
      this.$refs.markProblemOrder.openBatch(this.checkList, this.arrProblemType, () => { this.refresh() })
    },
    bindMarkException(item) {
      const state = item.is_exception == 1 ? 0 : 1
      const actionText = state === 1 ? '标记为异常订单' : '取消异常标记'
      this.$confirm(`确认${actionText}？异常订单不参与自动采购和手动采购。`, '提示', { type: 'warning' }).then(() => {
        this.opOrderManageBatchMarkException({
          data: { ids: String(item.id), state },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    bindBatchMarkException() {
      if (!this.checkList.length) {
        this.$message({ message: '请先选择需要标记的订单', type: 'error' })
        return
      }
      this.$confirm('确认将所选订单标记为异常？异常订单不参与自动采购和手动采购。', '提示', { type: 'warning' }).then(() => {
        this.opOrderManageBatchMarkException({
          data: { ids: this.checkList.join(','), state: 1 },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    /* ── 采购 ── */
    bindAlibabaPurchaseNew(row) {
      if (row.is_exception == 1) {
        this.$message({ message: '异常订单不支持采购，请先取消异常标记', type: 'error' })
        return
      }
      if (row.tracking_no || row.order_status == 3 || row.can_edit_dd_deliver == 1) {
        this.$message({ message: '订单已发货，不支持采购', type: 'error' })
        return
      }
      if (row.is_abnormal > 0) {
        this.$message({ message: '问题单不支持厂家直采，请先取消问题标记', type: 'error' })
        return
      }
      this.$confirm(row.pdd_status == 102 ? '确认重采失败卖家组？（已成功冻结组不会重复采购）' : '确认厂家直采操作?', '提示', { type: 'warning' }).then(() => {
        this.handleAlibabaPurchaseNew(row.id)
      }).catch(() => {})
    },
    bindBatAlibabaPurchase() {
      if (!this.checkList.length) {
        this.$message({ message: '请先选择需要采购的订单', type: 'error' })
        return
      }
      const abnormalCount = this.list.filter(item => this.checkList.includes(item.id) && item.is_abnormal > 0).length
      if (abnormalCount > 0) {
        this.$message({ message: '所选订单包含问题单，问题单不支持厂家直采', type: 'error' })
        return
      }
      const exceptionCount = this.list.filter(item => this.checkList.includes(item.id) && item.is_exception == 1).length
      if (exceptionCount > 0) {
        this.$message({ message: '所选订单包含异常订单，异常订单不支持采购', type: 'error' })
        return
      }
      const shippedCount = this.list.filter(item => this.checkList.includes(item.id) && (item.can_manual_dd_deliver != 1 && (item.tracking_no || item.order_status == 3))).length
      if (shippedCount > 0) {
        this.$message({ message: '所选订单包含已发货订单，已发货订单不支持采购', type: 'error' })
        return
      }
      this.$confirm('确认批量厂家直采操作?', '提示', { type: 'warning' }).then(() => {
        this.handleAlibabaPurchaseNew(this.checkList.join(','))
      }).catch(() => {})
    },
    handleAlibabaPurchaseNew(ids) {
      this.opOrderManageBatPurchase({
        data: { ids, buy_mode: 3 },
        success: (res) => {
          this.$alert(res.msg, '提示', {
            type: 'success',
            center: true,
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            callback: () => { this.refresh() }
          })
        }
      })
    },
    bindStockPurchase(row) {
      if (row.is_exception == 1) {
        this.$message({ message: '异常订单不支持采购，请先取消异常标记', type: 'error' })
        return
      }
      this.$confirm('确认仓库直发?', '提示', { type: 'warning' }).then(() => {
        this.opOrderManageBatPurchase({
          data: { ids: row.id, account_id: -1, buy_mode: 4 },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    postPurchcase(ids, ali_order_type = 0, group_id = '') {
      const param = { ids, ali_order_type, group_id }
      this.ali_order_type = ali_order_type
      this.$refs.pddAccountConfirm.open(param, this.opOrderManageBatPurchase, (res) => {
        if (res.code === 200) {
          this.$message.success(res.msg)
          this.refresh()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    bindBatCancelPurchase() {
      if (!this.checkList.length) {
        this.$message({ message: '请勾选订单', type: 'error' })
        return
      }
      this.$confirm('确认取消采购操作?', '提示', { type: 'warning' }).then(() => {
        this.opOrderManageDelPddOrder({
          data: { ids: this.checkList.join(',') },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    delPurchase(row) {
      this.$confirm('确认取消采购操作?', '提示', { type: 'warning' }).then(() => {
        this.opOrderManageDelPddOrder({
          data: { ids: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    repealPurchase(row) {
      this.$confirm('确认重新采购操作?', '提示', { type: 'warning' }).then(() => {
        this.opOrderManageRepealPurchase({
          data: { ids: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    needSyncOrder(row) {
      this.$confirm('确认同步采购操作?', '提示', { type: 'warning' }).then(() => {
        this.opOrderManageNeedSyncPddOrder({
          data: { ids: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    afterSales(row) {
      this.$confirm('确认同步抖店操作?', '提示', { type: 'warning' }).then(() => {
        this.opOrderManageUpdateOrderAfterSale({
          data: { ids: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    fetchAlibabaSendTime(row) {
      if (!row.order_alibaba_order || !row.order_alibaba_order.can_fetch_send_time) return
      this.opOrderManageFetchAlibabaSendTime({
        data: { id: row.id },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success(res.msg || '获取成功')
            if (row.order_alibaba_order && res.data) {
              row.order_alibaba_order.send_time = res.data.send_time || 0
              row.order_alibaba_order.send_time_str = res.data.send_time_str || ''
              row.order_alibaba_order.can_fetch_send_time = 0
              row.order_alibaba_order.show_send_time_row = 1
            } else {
              this.refresh()
            }
          } else {
            this.$message.error(res.msg || '获取失败')
          }
        },
        fail: () => {
          this.$message.error('获取失败')
        }
      })
    },
    toDoOrderPay(row) {
      this.$confirm('确定支付该采购订单吗', '提示', { type: 'warning' }).then(() => {
        this.opDoOrderPay({
          data: { ids: row.id },
          success: (res) => {
            if (res.code === 200) {
              if (res.data && res.data.pay_url) {
                window.open(res.data.pay_url, '_blank')
                this.$message.success(res.msg || '请在新窗口完成1688支付')
              } else {
                this.$message.success(res.msg)
              }
              this.refresh()
            } else {
              if (res.msg == '支付失败未签约或未绑定') this.showOpenPay()
              else this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    showOpenPay() {
      const html = `<div>
        <p style="font-weight: bold;font-size: 14px;">开启后，免密订单笔数无限制，采购更快捷</p>
        <p style="font-size: 12px;">1、请使用当前登录的1688账号绑定支付宝；</p>
        <p style="font-size: 12px;">2、且务必宝石支付宝余额充足，余额不足将不能支付；</p>
        <p style="font-size: 12px;">3、单笔支付限额500元/笔;支付笔数不限。</p>
      </div>`
      this.$alert(html, '请先开通支付宝免密支付', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '去开通',
        cancelButtonText: '暂不开通',
        closeOnClickModal: true,
        closeOnPressEscape: true,
        showClose: false,
        showCancelButton: true,
        customClass: 'zdy-message-box'
      }).then(() => {
        window.open('https://tradeconfig.1688.com/foundation/withhold_manage.htm')
      })
    },
    /* ── 删除/恢复/完结 ── */
    bindBatDelete() {
      this.postDeleteOrder(this.checkList.join(','))
    },
    postDeleteOrder(ids) {
      this.deleteConfirmIds = ids
      this.deleteConfirmText = ''
      this.dialog.deleteOrderDialog = true
    },
    onDeleteOrderDialogClosed() {
      this.deleteConfirmText = ''
      this.deleteConfirmIds = ''
    },
    confirmDeleteOrder() {
      if (this.deleteConfirmText !== '确认删除') {
        return
      }
      const ids = this.deleteConfirmIds
      this.dialog.deleteOrderDialog = false
      this.opOrderManageDeleteProduct({
        data: {ids: ids},
        success: (res) => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        }
      })
    },
    cancelDelete(row) {
      this.$confirm('确认恢复操作?', '提示', { type: 'warning' }).then(() => {
        this.opOrderManageCancelDelete({
          data: { ids: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    setNotDeal(id = null) {
      let checkList = this.checkList
      if (id !== null) checkList = [id]
      if (!checkList.length) {
        this.$message({ message: '请勾选订单', type: 'error' })
        return
      }
      this.$confirm('确认完结该订单? 确认后不可逆', '提示', { type: 'warning' }).then(() => {
        this.opOrderManageSetNotDealOrder({
          data: { ids: checkList.join(',') },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    /* ── 发货 ── */
    bindManualDdDeliver(item) {
      this.$refs.ddDeliverDialog.openManual(item, () => { this.refresh() })
    },
    bindEditDdDeliver(item) {
      this.$refs.ddDeliverDialog.openEdit(item, () => { this.refresh() })
    },
    /* ── 导出/同步 ── */
    orderExport() {
      if (this.isLoading) return
      this.$confirm('确认导出订单操作?', '提示', { type: 'warning' }).then(() => {
        this.isLoading = true
        const param = this.buildListParam({ is_export: 1, order_ids: this.checkList })
        this.getOrderManageList({
          data: param,
          success: (res) => {
            this.isLoading = false
            if (res.code === 200) {
              window.location.href = res.data
            } else {
              this.$message({ message: res.msg, type: 'error' })
            }
          }
        })
      }).catch(() => {})
    },
    openSyncDdOrderQueue() {
      this.dialog.syncDdOrderQueueDialog = true
    },
    /* ── 编辑 ── */
    editProductCode(row, index) {
      let pdd_sku_id = ''
      this.$refs.modifyConfirm.open('商品编码', row.pdd_sku_id ?? row.pdd_code, this.opUpdateOrderProduct, (val) => {
        pdd_sku_id = val
        return { pdd_sku_id: val, id: row.id }
      }, (res) => {
        if (res.code === 200) {
          this.$message.success(res.msg)
          this.list[index].pdd_sku_id = pdd_sku_id
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    editPddAccount(row) {
      this.$refs.modifyConfirm.open('采购账号', row.pdd_order.account, this.opUpdatePddAccount, (val) => {
        return { account: val, ids: row.id }
      }, (res) => {
        if (res.code === 200) {
          this.$message.success(res.msg)
          this.refresh()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    editPddOrderNo(row) {
      this.$refs.modifyConfirmOrderNo.open('设置采购单号', { order_no: row.pdd_order && row.pdd_order.order_id, account: row.pdd_order && row.pdd_order.account }, this.opUpdatePddOrderNo, (val) => {
        return { pdd_order_no: val.pdd_order_no, pdd_account_id: val.pdd_account_id, ids: row.id }
      }, (res) => {
        if (res.code === 200) {
          this.$message.success(res.msg)
          this.refresh()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    editBuyMode(row) {
      this.$confirm('确定切换采购模式吗? 切换后请重新启动任务', '提示', { type: 'warning' }).then(() => {
        this.opUpdateBuyMode({
          data: { ids: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    editAddress(row) {
      this.$refs.modifyReturnAddress.open('修改退货地址', row, this.opSetPddReturnAddress, (row) => {
        const map = ['id', 'name', 'phone', 'province_name', 'city_name', 'town_name', 'street_name', 'detail']
        const detail = {}
        for (let key of map) detail[key] = row[key]
        return detail
      }, () => { this.refresh() })
    },
    editAlibabaAddress(row,group) {
      const alibabaOrderId = String(group?.alibaba_order_id || '').trim()
      this.$refs.orderReturnAddress.open( '退换货地址', row.dd_order_id, () => {
            this.refresh();
          }, {
            alibaba_order_id: alibabaOrderId,
            readonly: Number(row.return_address_readonly) === 1,
          }
      )
    },
    refreshReturnAddress(row) {
      this.$confirm('确定重新获取地址吗?', '提示', { type: 'warning' }).then(() => {
        this.opRefreshReturnAddress({
          data: { ids: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.refresh()
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    showOriginalOrder(dd_order_id, type = 1) {
      if (type === 2) {
        this.searchData.dd_order_id = dd_order_id
      } else {
        this.searchData.dd_order_id = dd_order_id.substring(0, dd_order_id.length - 1)
      }
      this.refresh()
    },
    /* ── 关联 ── */
    callCG(arr) {
      this.cg_data = JSON.stringify(arr)
      this.$refs.child.showConnectGood()
    },
    alibabaCG(arr) {
      this.cg_data = JSON.stringify(arr)
      this.$refs.alibaba.showConnectGood()
    },
    openBatchAlibabaConnect() {
      if (!this.checkList.length) {
        this.$message({ message: '请先勾选订单', type: 'warning' })
        return
      }
      const bySku = new Map()
      for (const id of this.checkList) {
        const row = this.list.find((i) => i.id === id)
        if (!row) continue
        const key = row.sku_id != null && row.sku_id !== '' ? String(row.sku_id) : `id_${row.id}`
        if (!bySku.has(key)) bySku.set(key, row)
      }
      const items = [...bySku.values()]
      if (!items.length) {
        this.$message({ message: '未找到勾选订单数据', type: 'warning' })
        return
      }
      this.$refs.batchAlibabaConnect.open(items)
    },
    onBatchAlibabaConnectRefresh() {
      this.getList(true, this.pageData.page, () => {
        const batch = this.$refs.batchAlibabaConnect
        if (batch && batch.visible) batch.syncSkuItemsFromList(this.list)
      })
    },
    /* ── 阿里相关 ── */
    isValidAlibabaPddCode(item) {
      const c = item && item.pdd_code
      if (c === undefined || c === null || String(c).trim() === '') return false
      if (String(c).includes('规格失效')) return false
      return true
    },
    isAlibabaDirectLinked(item) {
      if (item && item.alibaba_items && item.alibaba_items.length) return true
      return Number(item.source_type) === 2 && this.isValidAlibabaPddCode(item)
    },
    canEditAlibabaDirectLink() {
      return true
    },
    getPurchaseReturnAddressInfo(item, group) {
      const map = item && item.purchase_return_addresses && typeof item.purchase_return_addresses === 'object'
          ? item.purchase_return_addresses
          : null
      const oid = String(group?.alibaba_order_id || '').trim()
      if (map && oid && map[oid]) return map[oid]
      if (map && map._default) return map._default
      return {
        state: Number(item?.return_address_state ?? 10),
        error: String(item?.return_address_error || ''),
        state_text: String(item?.return_address_state_text || ''),
        origin_detail: '',
        merchant_address_text: '',
      }
    },
    getPurchaseReturnAddressState(item, group) {
      return Number(this.getPurchaseReturnAddressInfo(item, group).state ?? 10)
    },
    getPurchaseReturnAddressError(item, group) {
      return String(this.getPurchaseReturnAddressInfo(item, group).error || '')
    },
    getPurchaseReturnAddressLabel(item, group) {
      const text = String(this.getPurchaseReturnAddressInfo(item, group).state_text || '').trim()
      if (!text) return '未设置'
      const matched = text.match(/^\d{4}\/\d{2}\/\d{2}\s+\d{2}:\d{2}:\d{2}\s+(.+)$/)
      return matched ? matched[1] : text
    },
    getPurchaseReturnAddressTime(item, group) {
      const text = String(this.getPurchaseReturnAddressInfo(item, group).state_text || '').trim()
      const matched = text.match(/^(\d{4}\/\d{2}\/\d{2}\s+\d{2}:\d{2}:\d{2})/)
      return matched ? matched[1] : ''
    },
    getPurchaseReturnAddressClass(item, group) {
      const state = this.getPurchaseReturnAddressState(item, group)
      if (state === 30) return 'is-success'
      if (state <= 0) return 'is-error'
      if (state <= 10) return 'is-pending'
      return 'is-processing'
    },
    openAlibabaWangwangChat(wangwangAccount) {
      const account = String(wangwangAccount || '').trim()
      if (!account) {
        this.$message({ message: '暂无上家旺旺', type: 'warning' })
        return
      }
      const wangwangId = account.replace(/^cnalichn/i, '')
      const touid = encodeURIComponent('cnalichn' + wangwangId)
      const url = `https://air.1688.com/app/ocms-fusion-components-1688/def_cbu_web_im/index.html?&touid=${touid}&siteid=cnalichn&status=1&portalId=&gid=&offerId=&itemsId=&spmid=a261y.7663282.0#/`
      window.open(url, '_blank')
    },
    openAlibabaOfferDetail(offerId) {
      const id = String(offerId || '').trim()
      if (!id) {
        this.$message({ message: '暂无1688商品链接', type: 'warning' })
        return
      }
      window.open(`https://detail.1688.com/offer/${id}.html?offerId=${id}`, '_blank')
    },
    isAlibabaPurchaseOrder(pddOrder) {
      return Number(pddOrder && pddOrder.buy_mode) === 3 && !!String(pddOrder.order_id || '').trim()
    },
    openAlibabaOrderDetail(pddOrder) {
      if (!this.isAlibabaPurchaseOrder(pddOrder)) return
      const orderId = String(pddOrder.order_id).trim()
      window.open(`https://air.1688.com/app/ctf-page/trade-order-detail/index.html?orderId=${encodeURIComponent(orderId)}`, '_blank')
    },
    /**售后倒计时**/
    getAftersaleCountdownText(item) {
      void this.nowTick
      const aftersale = item && item.order_after_sales
      if (!aftersale) return ''
      const raw = aftersale.status_deadline
      let ts = parseInt(raw, 10)
      if (!ts || ts <= 0) return ''
      const endMs = ts < 1e12 ? ts * 1000 : ts
      const left = Math.floor((endMs - Date.now()) / 1000)
      if (left <= 0) return '00 秒'
      const d = Math.floor(left / 86400)
      const restAfterDay = left % 86400
      const h = Math.floor(restAfterDay / 3600)
      const m = Math.floor((restAfterDay % 3600) / 60)
      const s = restAfterDay % 60
      const parts = []
      if (d > 0) parts.push(`${d} 天`)
      if (d > 0 || h > 0) parts.push(`${h} 小时`)
      parts.push(`${m} 分`, `${s} 秒`)
      return parts.join(' ')
    },
    goOrderAftersaleDetail(item) {
      const aftersale = item && item.order_after_sales
      if (!aftersale || !aftersale.id) {
        this.$message({ message: '缺少售后记录 ID', type: 'warning' })
        return
      }
      const route = this.$router.resolve({
        path: '/uc_after_sales_detail',
        query: { id: String(aftersale.id) },
      })
      window.open(route.href, '_blank')
    },
    /**查询是否永久关联*/
    querySkuPermanentRelative(item) {
      const skuId = item && item.sku_id != null ? String(item.sku_id).trim() : ''
      if (!skuId || skuId === '0') {
        this.$message({ message: '暂无规格ID', type: 'warning' })
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '查询中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      this.GetQuerySkuRelativeInfo({
        data: { sku_id: skuId },
        success: (res) => {
          loading.close()
          if (res.code == 200) {
            const offerIds = this.resolvePermanentOfferIds(res.data)
            if (!offerIds.length) {
              this.$message({ type: 'error', message: '未解析到已关联的1688商品' })
              return
            }
            const linksHtml = offerIds.map((id, idx) => {
              const url = this.getAlibabaOfferDetailUrl(id)
              const label = '关联' + (idx + 1)
              if (!url) return `<span>${label}</span>`
              return `<a class="query_permanent_offer_link" style="color: #409EFF;	cursor: pointer;	text-decoration: none;" href="${url}" target="_blank" rel="noopener">${label}</a>`
            }).join('、')
            this.$alert(`<p class="query_permanent_yes">是</p><p class="query_permanent_offers">${linksHtml}</p>`, '永久关联查询', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '关闭',
              type: 'success',
              center: true,
            }).catch(() => {})
          } else {
            this.$message({
              type: 'error',
              message: res.msg || '查询失败'
            })
          }
        },
        error: () => {
          loading.close()
          this.$message({ type: 'error', message: '查询失败' })
        }
      })
    },

    /** 永久关联接口：offers / source_product_ids / 旧 source_product_id */
    resolvePermanentOfferIds(data) {
      if (!data) return []
      if (Array.isArray(data.offers) && data.offers.length) {
        const ids = data.offers.map(o => String((o && (o.alibaba_goods_id || o.source_product_id)) || '').trim()).filter(Boolean)
        if (ids.length) return ids
      }
      if (Array.isArray(data.source_product_ids) && data.source_product_ids.length) {
        return data.source_product_ids.map(id => String(id || '').trim()).filter(Boolean)
      }
      const one = String(data.source_product_id || '').trim()
      return one ? [one] : []
    },
    /** 抖店已关闭/退款完结：不再展示取消采购类按钮 */
    isDdOrderClosedForCancelPurchase(item) {
      if (!item) return true
      const os = Number(item.order_status || 0)
      // 4已取消 / 21发货前退款完结 / 22发货后退款完结 / 39收货后退款完结
      return [4, 21, 22, 39].includes(os)
    },
    /** 采购单已终态（已取消/申请退款/退款完成） */
    isPurchaseTerminal(item) {
      const st = Number(item?.pdd_order?.status ?? item?.pdd_status ?? 0)
      // 90已取消 / 140申请退款 / 150退款完成
      return [90, 140, 150].includes(st)
    },
    /**
     * 操作列：未挂主单号时的「取消采购」（待付/下单中）
     * 改动目的：售后清空 order_id 后勿误显；时间：2026-08-19
     */
    canShowCancelPurchaseUnpaid(item) {
      if (!item?.pdd_order || item.delete_time) return false
      if (this.isDdOrderClosedForCancelPurchase(item)) return false
      if (this.isPurchaseTerminal(item)) return false
      const oid = String(item.pdd_order.order_id || '').trim()
      const st = Number(item.pdd_order.status || 0)
      // 仅：尚无主单号的在途采购，或本地已标取消待清（90 且仍可操作的历史场景不再开）
      return !oid && st > 0 && st < 90
    },
    /**
     * 操作列：已挂主单号时的「取消采购」
     * 改动目的：抖店已取消/采购退款完结后隐藏；时间：2026-08-19
     */
    canShowCancelPurchasePaid(item) {
      if (!item?.pdd_order || item.delete_time) return false
      if (this.isDdOrderClosedForCancelPurchase(item)) return false
      if (this.isPurchaseTerminal(item)) return false
      const oid = String(item.pdd_order.order_id || '').trim()
      if (!oid) return false
      const st = Number(item.pdd_order.status || 0)
      // 已发货(130+)/申请退款(140)不可整单取消
      return st > 90 && st < 130
    },
    /** 单组取消：未付/已付未发可取消；已发货/已取消/退款中不可；时间：2026-08-19 */
    canCancelPurchaseGroup(item, group) {
      if (!item || !group) return false
      if (this.isDdOrderClosedForCancelPurchase(item)) return false
      if (this.isPurchaseTerminal(item)) return false
      if (Number(item.combo_type) !== 2 && !(item.alibaba_items && item.alibaba_items.length >= 2)) return false
      const oid = String(group.alibaba_order_id || '').trim()
      if (!oid) return false
      const aliStatus = String(group.alibaba_status || '').toLowerCase()
      // 已发货 / 已取消终态不可再取消
      if (['waitbuyerreceive', 'confirm_goods', 'success', 'cancel', 'terminated'].includes(aliStatus)) return false
      const refundStatus = String(group.refund_status || '').toLowerCase()
      if (['waitselleragree', 'waitbuyermodify', 'waitbuyersend', 'waitsellerreceive', 'refundsuccess'].includes(refundStatus)) {
        return false
      }
      const lines = Array.isArray(group.lines) ? group.lines : []
      if (!lines.length) return false
      // 组内已有上游发货/主运单 → 不可单组取消
      if (lines.some((l) => [40, 50].includes(Number(l.line_status || 0)))) return false
      // 整组已取消/失败：不再显示取消
      if (lines.every((l) => [90, 100].includes(Number(l.line_status || 0)))) return false
      // 仅待采/下单中/待付/待发可取消
      return lines.every((l) => {
        const st = Number(l.line_status || 0)
        return [0, 10, 20, 30].includes(st)
      })
    },
    hasPurchaseGroupAmount(group) {
      if (!group) return false
      return Number(group.pdd_pay_amount || 0) > 0 || Number(group.shipping_fee || 0) > 0 || Number(group.total_amount || 0) > 0
    },
    /** 货品信息：跨卖家多主单时采购价/代发费取各组之和；时间：2026-08-19 */
    getGoodsPurchaseCost(item) {
      const groups = this.getPurchaseGroups(item) || []
      const withAmt = groups.filter((g) => Number(g.pdd_pay_amount || 0) > 0 || Number(g.shipping_fee || 0) > 0)
      if (withAmt.length >= 2) {
        const pay = withAmt.reduce((s, g) => s + Number(g.pdd_pay_amount || 0), 0)
        const ship = withAmt.reduce((s, g) => s + Number(g.shipping_fee || 0), 0)
        return { pay: this.formatMoney(pay), freight: this.formatMoney(ship) }
      }
      return {
        pay: item.pdd_order?.pdd_pay_amount ?? '0.00',
        freight: item.pdd_order?.freight ?? item.pdd_order?.shipping_fee ?? '0.00',
      }
    },
    formatMoney(val) {
      const n = Number(val)
      if (!Number.isFinite(n)) return '0.00'
      return n.toFixed(2)
    },
    delPurchaseGroup(row, group) {
      const oid = String(group?.alibaba_order_id || '').trim()
      if (!oid) {
        this.$message({ type: 'error', message: '缺少采购单号' })
        return
      }
      const aliStatus = String(group?.alibaba_status || '').toLowerCase()
      const tip = aliStatus === 'waitsellersend'
          ? '确认取消该卖家组采购？将申请1688退款，其它组不受影响。'
          : '确认取消该卖家组采购？（其它组不受影响）'
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opOrderManageDelPddOrder({
          data: { ids: row.id, alibaba_order_id: oid },
          success: (res) => {
            if (res.code == 200) {
              this.$message({ type: 'success', message: res.msg })
              this.refresh()
            } else {
              this.$message({ type: 'error', message: res.msg })
            }
          }
        })
      }).catch(() => {})
    },

    /** 组合采购下全部有效 1688 主单号（去重） */
    getAlibabaOrderIds(item) {
      const ids = []
      const seen = {}
      const push = (id) => {
        const s = String(id || '').trim()
        if (!s || seen[s]) return
        seen[s] = true
        ids.push(s)
      }
      this.getPurchaseGroups(item).forEach((g) => push(g.alibaba_order_id))
      if (!ids.length) {
        push(item?.pdd_order?.order_id)
        push(item?.order_alibaba_order?.alibaba_order_id)
      }
      return ids
    },

    /**
     * —— 更多巴巴单号 ——  */
    hasMultipleAlibabaOrders(item) {
      return Number(item?.pdd_order?.buy_mode) === 3 && this.getAlibabaOrderIds(item).length > 1
    },
    openAlibabaOrderIdsDialog(item) {
      this.alibabaOrderIdsDialogList = this.getAlibabaOrderIds(item)
      if (this.alibabaOrderIdsDialogList.length <= 1) {
        const only = this.alibabaOrderIdsDialogList[0] || item?.pdd_order?.order_id
        if (only) this.bindCopy(only)
        return
      }
      this.dialog.alibabaOrderIdsDialog = true
    },

    /** 采购状态文案（含 102）；FE-B；2026-08-17 */
    getPurchaseStatusText(item) {
      if (item?.pdd_order?.status_name) return item.pdd_order.status_name
      if (item?.pdd_status_text) return item.pdd_status_text
      if (item?.abb_purchase_msg) return item.abb_purchase_msg
      return '暂无'
    },
    /** 状态文案关键字 → 标签色调：red / green / orange / blue / gray */
    getStatusTone(text) {
      const t = String(text == null ? '' : text).trim()
      if (!t || t === '暂无' || t === '--') return 'gray'
      if (/失败|异常|拒绝|驳回|缺货|超时|风险|拦截|中断/.test(t)) return 'red'
      // 取消/关闭类：终态归灰；含“可重采/待采购”等仍需商家操作的归橙；取消进行中归蓝
      if (/取消|作废|撤销|关闭|完结|终止/.test(t)) {
        if (/可重采|重采|待采购|待付款|待支付|待发货|待处理/.test(t)) return 'gray'
        if (/取消中|撤销中|关闭中/.test(t)) return 'blue'
        return 'gray'
      }
      // 无“取消”字样但明确等待重采的，同样归橙
      if (/可重采|待重采/.test(t)) return 'orange'
      if (/成功|已发货|待收货|已签收|已完成|完成|已入库/.test(t)) return 'green'
      if (/待付款|待支付|待采购|待发货|待确认|待审核|待处理|备货|未支付|未采购|退款中|退货中/.test(t)) return 'orange'
      if (/已支付|处理中|同步|采购中|发货中|进行中|配送中|运输中|已下单/.test(t)) return 'blue'
      return 'gray'
    },
    /** 厂家直采 / 102 重采失败组入口；抖店已取消不展示 */
    canShowAlibabaPurchase(item) {
      if (!item || item.delete_time || Number(item.is_exception) === 1 || Number(item.is_abnormal) > 0) return false
      if (this.isDdOrderClosedForCancelPurchase(item)) return false
      if (Number(item.source_type) !== 2) return false
      const st = Number(item.pdd_status || 0)
      if (st === 102 || st === 101) return true
      return !item.pdd_order
    },
    /**
     * 采购单详情：按 1688 采购单（alibaba_order_id / 卖家组）分组展示
     * 改动目的：列表按每个采购单显示；时间：2026-08-17
     */
    getPurchaseGroups(item) {
      if (!item) return []
      const lines = Array.isArray(item.alibaba_items) ? item.alibaba_items : []
      if (lines.length) {
        const map = {}
        lines.forEach((line) => {
          const oid = String(line.alibaba_order_id || '').trim()
          const gkey = String(line.seller_group_key || line.albb_seller_id || 'pending')
          const key = oid || ('wait_' + gkey)
          if (!map[key]) {
            map[key] = {
              key,
              alibaba_order_id: oid,
              seller_group_key: gkey,
              wangwang_account: String(line.wangwang_account || ''),
              lines: [],
              has_fail: false,
              is_frozen: true,
              tracking_list: [],
              status_text: '',
              status_code: 0,
              account_text: item.pdd_order?.buy_mode == 3 ? '厂家直采' : (item.pdd_order?.account || ''),
              express_no: '',
              link: null,
              pdd_pay_amount: Number(line.pdd_pay_amount || 0),
              shipping_fee: Number(line.shipping_fee || 0),
              total_amount: Number(line.total_amount || 0),
              alibaba_status: String(line.alibaba_status || ''),
            }
          }
          map[key].lines.push(line)
          if (Number(line.pdd_pay_amount || 0) > 0 || Number(line.shipping_fee || 0) > 0) {
            map[key].pdd_pay_amount = Number(line.pdd_pay_amount || 0)
            map[key].shipping_fee = Number(line.shipping_fee || 0)
            map[key].total_amount = Number(line.total_amount || (Number(line.pdd_pay_amount || 0) + Number(line.shipping_fee || 0)))
          }
          if (line.alibaba_status) {
            map[key].alibaba_status = String(line.alibaba_status)
          }
          if (Number(line.line_status) === 90 || Number(line.line_status) === 100) {
            map[key].has_fail = true
          }
          if (Number(line.is_frozen) !== 1) {
            map[key].is_frozen = false
          }
          if (!map[key].wangwang_account && line.wangwang_account) {
            map[key].wangwang_account = line.wangwang_account
          }
          if (line.tracking_no) {
            const exists = map[key].tracking_list.some(t => t.no === line.tracking_no)
            if (!exists) {
              map[key].tracking_list.push({
                no: line.tracking_no,
                main: Number(line.is_dd_main_ship) === 1,
              })
            }
          }
          // 组状态取「最差」：失败 > 待采 > 成功文案
          const st = Number(line.line_status || 0)
          if (!map[key].status_text || st === 90 || st === 100) {
            map[key].status_text = line.line_status_text || ''
            map[key].status_code = st
          }
        })
        return Object.values(map)
      }
      if (this.isAlibabaDirectLinked(item) || (item.pdd_order && item.pdd_order.order_id)) {
        const oid = String(item.pdd_order?.order_id || item.order_alibaba_order?.alibaba_order_id || '')
        return [{
          key: 'legacy_' + (oid || item.id),
          alibaba_order_id: oid,
          wangwang_account: item.alibaba_direct_link?.wangwang_account || '',
          lines: [],
          has_fail: Number(item.pdd_status) === 101 || Number(item.pdd_status) === 102,
          is_frozen: false,
          tracking_list: item.pdd_order?.express_no ? [{ no: item.pdd_order.express_no, main: true }] : [],
          status_text: this.getPurchaseStatusText(item),
          status_code: Number(item.pdd_status || item.pdd_order?.status || 0),
          account_text: item.pdd_order?.buy_mode == 3 ? '厂家直采' : (item.pdd_order?.account || ''),
          express_no: item.pdd_order?.express_no || '',
          link: item.alibaba_direct_link || null,
          pdd_pay_amount: Number(item.pdd_order?.pdd_pay_amount || 0),
          shipping_fee: Number(item.pdd_order?.shipping_fee || item.pdd_order?.freight || 0),
          total_amount: Number(item.pdd_order?.pdd_pay_amount || 0) + Number(item.pdd_order?.shipping_fee || item.pdd_order?.freight || 0),
          alibaba_status: String(item.order_alibaba_order?.alibaba_status || ''),
        }]
      }
      return []
    },
    openAlibabaOrderById(orderId) {
      const id = String(orderId || '').trim()
      if (!id) return
      this.openAlibabaOrderDetail({ buy_mode: 3, order_id: id })
    },

  }
}
</script>

<style scoped>
.area-col{
  display: flex;
  flex-direction: column;
}
.area-col-top{
  justify-content: flex-start;
}
.area-col-center{
  justify-content: center;
}
.red {
  color: #C8443C;
}
.gx-od__filter {
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 12px;
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  display: flex;
  gap: 10px 14px;
  align-items: center;
  flex-wrap: wrap;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.gx-od__filter-range {
  display: flex;
  align-items: center;
  gap: 4px;
}
.gx-od__filter-btn{
  height: 30px;
  padding: 0px 16px;
  border-radius: 4px;
  cursor: pointer;
  background: rgb(245, 245, 245);
  border: 1px solid rgb(224, 224, 236);
  box-sizing: border-box;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(26, 26, 46);
  transition: 0.15s;
}
.gx-od__filter-btn:hover{
  background: rgb(232,232,232);
}
.gx-od__filter-btn~.gx-od__filter-btn{
  margin-left: 8px;
}
/*.gx-od__fitem {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.gx-od__flabel {
  font-size: 12px;
  color: #606266;
  white-space: nowrap;
  font-weight: 500;
}
.gx-od__fitem--btns {
  margin-left: auto;
}
.gx-od__input {
  width: 150px;
  height: 32px;
  padding: 0 11px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  font-size: 12px;
  color: #303133;
  outline: none;
  box-sizing: border-box;
  transition: border-color .15s ease;
}
.gx-od__input:focus {
  border-color: #C8443C;
}
.gx-od__input--num {
  width: 90px;
}
.gx-od__input--date {
  width: 165px;
}
.gx-od__range-sep {
  color: #909399;
  font-size: 12px;
}
.gx-od__select {
  height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  background: #FFFFFF;
  font-size: 12px;
  color: #303133;
  outline: none;
  min-width: 110px;
  transition: border-color .15s ease;
}
.gx-od__select:focus {
  border-color: #C8443C;
}*/
.gx-od__btn {
  height: 32px;
  padding: 0 15px;
  border-radius: 6px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  font-size: 12px;
  color: #606266;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all .15s ease;
  font-weight: 500;
}
.gx-od__btn:hover:not(:disabled) {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F4;
}
.gx-od__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
/*.gx-od__btn--primary {
  background: linear-gradient(135deg, #E85D4E, #F47B5A);
  border-color: transparent;
  color: #FFFFFF;
  box-shadow: 0 2px 4px rgba(232, 93, 78, .25);
}
.gx-od__btn--primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #D44A3C, #E8694A);
  box-shadow: 0 3px 8px rgba(232, 93, 78, .35);
}*/
.gx-od__btn--danger {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #C8443C;
  font-weight: 500;
}
.gx-od__btn--danger:hover:not(:disabled) {
  background: #FFE5E3;
  border-color: #F5B5B0;
  color: #C8443C;
}
.gx-od__btn--loading {
  color: #FA8C16;
  border-color: #FFD591;
}
/* 列表面板卡片 */
.gx-od__card {
  border-radius: 10px;
  border: 1px solid #EBEEF5;
  background: #FFFFFF;
  overflow: visible;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.02);
  position: relative;
}
.gx-od__status-tabs {
  display: flex;
  margin-bottom: 0;
  overflow-x: auto;
  flex-wrap: nowrap;
  background: #FFFFFF;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid #EFE6D2;
  position: relative;
  z-index: 2;
}
.gx-od__status-tab {
  padding: 13px 16px 11px;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  background: #FAF6EE;
  font-size: 13px;
  color: #4A4A6A;
  position: relative;
  white-space: nowrap;
  flex-shrink: 0;
  border-radius: 0;
  transition: color .15s ease, border-color .15s ease, background-color .15s ease;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  /* margin-bottom: -1px; */
  border-right: 1px solid rgb(224, 224, 236);
}
.gx-od__status-tab:hover {
  color: #C8443C;
  background: transparent;
}
.gx-od__status-tab--on {
  background: rgb(255, 245, 245);
  border-bottom-color: #C8443C;
  color: #C8443C;
  font-weight: 600;
  border-radius: 4px 4px 0 0;
}
.gx-od__status-tab--on:hover {
  color: #C8443C;
  background: #FDECEB;
}
.gx-od__status-num {
  position: absolute;
  top: 5px;
  right: 3px;
  min-width: 15px;
  height: 15px;
  padding: 0 4px;
  border-radius: 8px;
  background: #E04B43;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  line-height: 15px;
  text-align: center;
  box-sizing: border-box;
}
.gx-od__batch {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #FAF6EE;
  border-bottom: 1px solid #EFE6D2;
  border-radius: 0;
  margin-bottom: 0;
  flex-wrap: wrap;
}
.gx-od__batch .gx-od__checkall {
  width: 70px;
}
.gx-od__batch-label {
  font-size: 12px;
  color: #606266;
  margin-right: 4px;
  font-weight: 500;
  line-height: 1;
}
.gx-od__batch .gx-od__btn {
  box-shadow: none;
}
.gx-od__damaged {
  margin: 0 0 0 auto;
  font-size: 13px;
  color: #C8443C;
  font-weight: 500;
}
.gx-od__damaged span {
  font-weight: 700;
  font-size: 14px;
}
/*.gx-od__table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 0;
  border-radius: 0;
  background: #FFFFFF;
  border: none;
  box-shadow: none;
}
.gx-od__table-wrap::-webkit-scrollbar {
  height: 8px;
}
.gx-od__table-wrap::-webkit-scrollbar-thumb {
  background: linear-gradient(90deg, #E85D4E, #F47B5A);
  border-radius: 4px;
}
.gx-od__table-wrap::-webkit-scrollbar-track {
  background: #FFF5F4;
  border-radius: 4px;
}*/
.gx-od__table tr{
  border-bottom: 1px solid rgb(224, 224, 236);
}
.gx-od__table th{
  padding: 9px 10px;
  text-align: left;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: var(--gx-black);
  letter-spacing: 0.02em;
  border-right: 1px solid rgb(224, 224, 236);
  white-space: nowrap;
  background: rgb(245, 240, 232);
}
.gx-od__table td{
  font-size: 12px;
  padding: 10px;
  vertical-align: top;
}
.gx-od__table td.td-middle{
  vertical-align: middle;
}
.gx-od__table th~th,
.gx-od__table td~td{
  border-left: 1px solid rgb(224, 224, 236);
}

.gx-od__thead {
  display: flex;
  align-items: stretch;
  padding: 0;
  background: #FAF6EE;
  border-bottom: 1px solid #EFE6D2;
  font-size: 12px;
  color: #4A4A6A;
  font-weight: 500;
}
.gx-od__th-check {
  width: 14px;
  flex-shrink: 0;
  margin: 0 12px 0 16px;
}
.gx-od__checkall {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  font-size: 12px;
  color: #606266;
  width: 90px;
  flex-shrink: 0;
  user-select: none;
  font-weight: 500;
}
.gx-od__checkall input[type='checkbox'] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gx-od__checkall-box {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1.5px solid #D0D0DD;
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all .15s ease;
}
.gx-od__checkall:hover .gx-od__checkall-box {
  border-color: #C8443C;
}
.gx-od__checkall input:checked + .gx-od__checkall-box {
  background: #C8443C;
  border-color: #C8443C;
  box-shadow: 0 1px 3px rgba(200, 68, 60, 0.18);
}
.gx-od__th {
  font-size: 12px;
  color: #4A4A6A;
  white-space: nowrap;
  font-weight: 500;
  display: flex;
  align-items: center;
  border-right: 1px solid #EFE6D2;
  box-sizing: border-box;
}
.gx-od__th--goods {
  flex: 1 1 auto;
  min-width: 400px;
  padding: 11px 16px 11px 0;
}
.gx-od__th--num {
  width: 120px;
  flex-shrink: 0;
  padding: 11px 8px 11px 12px;
}
.gx-od__th--sales {
  width: 250px;
  flex-shrink: 0;
  padding: 11px 12px;
}
.gx-od__th--pay {
  width: 140px;
  flex-shrink: 0;
  padding: 11px 12px;
}
.gx-od__th--buyer {
  width: 180px;
  flex-shrink: 0;
  padding: 11px 12px;
}
.gx-od__th--purchase {
  width: 320px;
  flex-shrink: 0;
  padding: 11px 12px;
}
.gx-od__th--ops {
  width: 140px;
  justify-content: center;
  flex-shrink: 0;
  padding: 11px 8px;
  border-right: none;
}
.gx-od__view {
  cursor: pointer;
  font-style: normal;
  margin-left: 6px;
  color: #909399;
  transition: color .15s ease;
}
.gx-od__view:hover {
  color: #C8443C;
}
.gx-od__list {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.gx-od__order {
  border-bottom: 1px solid #EBEEF5;
  background: #FFFFFF;
  overflow: hidden;
  transition: background-color .15s ease;
}
.gx-od__order:last-child {
  border-bottom: none;
}
.gx-od__order:hover {
  background: #FDFDFB;
}
/* 货品信息列：单号信息行 */
.gx-od__info-lines {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-bottom: 2px;
}
.gx-od__info-line {
  margin: 0;
  font-size: 11px;
  line-height: 1.7;
  color: #606266;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.gx-od__info-line.as-countdown {
  margin: 0;
}
.gx-od__shop--deleted {
  color: #C8443C;
}
.gx-od__shop {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  margin-right: 5px;
  color: rgb(106, 106, 138);
  font-weight: 600;
}
.gx-od__copy {
  cursor: pointer;
  margin-left: 6px;
  color: #909399;
  font-style: normal;
  font-size: 11px;
  transition: color .15s ease;
}
.gx-od__copy:hover {
  color: #C8443C;
}
.gx-od__edit {
  cursor: pointer;
  margin-left: 5px;
  color: #909399;
  font-style: normal;
  transition: color .15s ease;
}
.gx-od__edit:hover {
  color: #C8443C;
}
.gx-od__check {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1.5px solid #D0D0DD;
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: all .15s ease;
}
.gx-od__check svg {
  width: 7px;
  height: 7px;
}
.gx-od__check:hover {
  border-color: #C8443C;
}
.gx-od__check--on {
  background: #C8443C;
  border-color: #C8443C;
  box-shadow: 0 1px 3px rgba(200, 68, 60, 0.18);
}
.gx-od__top-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}
.gx-od__flags {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.gx-od__flag-box {
  padding: 2px 8px;
  border-radius: 4px;
  background: linear-gradient(180deg, #E6F7FF 0%, #D6F0FF 100%);
  border: 1px solid #91D5FF;
  color: #1890FF;
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
  font-weight: 500;
  transition: all .15s ease;
}
.gx-od__flag-box:hover {
  border-color: #40A9FF;
  box-shadow: 0 1px 3px rgba(24, 144, 255, 0.12);
}
.gx-od__flag-box--old {
  background: linear-gradient(180deg, #FAFAFA 0%, #F0F0F0 100%);
  border-color: #D9D9D9;
  color: #8C8C8C;
}
.gx-od__flag-box--damaged {
  background: linear-gradient(180deg, #FFF1F0 0%, #FFE8E6 100%);
  border-color: #FFCCC7;
  color: #C8443C;
}
.gx-od__damaged-amount {
  font-weight: 700;
}
.gx-od__order-id-link {
  color: #1677FF;
  cursor: pointer;
  transition: color .15s ease;
}
.gx-od__order-id-link:hover {
  color: #0E5DD8;
}
.gx-od__order-more {
  margin-left: 8px;
  font-size: 12px;
  color: #1677FF;
  line-height: 1;
  text-decoration: none;
  transition: color .15s ease;
}
.gx-od__order-more:hover {
  color: #0E5DD8;
  text-decoration: underline;
}
.gx-od__order-info {
  display: flex;
  align-items: stretch;
  padding: 0;
  gap: 0;
}
.gx-od__order-info > .gx-od__check {
  align-self: center;
  margin: 0 12px 0 16px;
}
/*货品信息列*/
.gx-od__product {
  flex: 1 1 auto;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gx-od__product .gx-od__goods-info {
  flex: 0 0 auto;
}
.gx-od__goods-info {
  display: flex;
  gap: 10px;
  flex: 1;
  min-width: 0;
}
.gx-od__thumb {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  background: #F8F8F8;
  border: 1px solid #F0F0F0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  overflow: hidden;
  cursor: zoom-in;
  transition: transform .15s ease, box-shadow .15s ease;
}
.gx-od__thumb:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.10);
}
.gx-od__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-od__con-box {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  line-height: 1.6;
}
.gx-od__product-title {
  font-size: 13px;
  color: #1A1A2E;
  line-height: 1.4;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0 0 3px;
}
.gx-od__product-title:hover {
  color: #C8443C;
}
.gx-od__dim {
  color: #909399;
  margin: 2px 0;
  font-size: 12px;
}
.gx-od__supplier {
  color: #FA8C16;
  margin: 2px 0;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}
.gx-od__red {
  color: #C8443C;
  margin: 2px 0;
  font-weight: 600;
}
.gx-od__stock {
  margin: 2px 0;
  font-size: 12px;
  color:rgb(153, 153, 153);
}
.gx-od__stock span {
  color: #333;
}
.gx-od__blue {
  color: #1677FF;
  cursor: pointer;
  margin-left: 8px;
}
.gx-od__link {
  color: #1677FF;
  cursor: pointer;
  margin: 2px 0;
  text-decoration: none;
  display: inline-block;
  transition: color .15s ease;
}
.gx-od__link:hover {
  text-decoration: underline;
  color: #0E5DD8;
}
/* 操作列：标记类入口 */
.gx-od__link--mark {
  height: 22px;
  padding: 0px 7px;
  border-radius: 3px;
  cursor: pointer;
  background: rgb(245, 245, 245);
  border: 1px solid rgb(224, 224, 236);
  font-size: 10px;
  color: rgb(102, 102, 102);
  line-height: 22px;
}
.gx-od__link--mark:hover {
  color: #C8443C;
}
.gx-od__link--mark.gx-od__link--warn {
  color: #FA8C16;
}
.gx-od__link--mark.gx-od__link--warn:hover {
  color: #D46B08;
}
.gx-od__link--mark.gx-od__link--danger {
  color: #C8443C;
  font-weight: 500;
}
.gx-od__link--mark.gx-od__link--danger:hover {
  color: #A5362F;
}
/*售价/数量列*/
.gx-od__product-num {
  min-width:90px;
  text-align: center;
  flex-shrink: 0;
}
.gx-od__product-num .gx-od__strong {
    font-size: 12px;
    color: rgb(200, 68, 60);
    font-weight: 600;
}
.gx-od__product-num .gx-od__num {
    font-size: 12px;
    color: rgb(26, 26, 46);
    font-weight: 600;
}
/*订单状态列*/
.gx-od__product-sales {
  min-width: 160px;
  flex-shrink: 0;
  line-height: 1.6;
}
.gx-od__product-sales p {
  margin: 3px 0;
  color: #606266;
}
.gx-od__st-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  margin: 2px 0 6px;
}
.gx-od__st-label {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}
.gx-od__st-badge {
  display: inline-block;
  max-width: 100%;
  padding: 1px 9px;
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.6;
  font-weight: 500;
  white-space: normal;
  word-break: break-word;
  box-sizing: border-box;
}
.gx-od__st-badge--blue {
  color: #1677FF;
  background: #EDF4FF;
  border-color: #A9CBFF;
}
.gx-od__st-badge--orange {
  color: #FA8C16;
  background: #FFF7E6;
  border-color: #FFD591;
}
.gx-od__st-badge--green {
  color: #389E0D;
  background: #F4FBEB;
  border-color: #B7EB8F;
}
.gx-od__st-badge--red {
  color: #C8443C;
  background: #FFF1F0;
  border-color: #FFCCC7;
}
.gx-od__st-badge--gray {
  color: #909399;
  background: #F7F8FA;
  border-color: #DCDFE6;
}
.gx-od__strong {
  font-weight: 600;
  color: #262626;
}
.gx-od__buyer-info {
  cursor: pointer;
  margin: 4px 0 2px;
  color: #1677FF!important;
  transition: color .15s ease;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  align-self: flex-start;
}
.gx-od__buyer-info .el-icon-info {
  font-size: 14px;
}
.gx-od__buyer-info:hover {
  color: #0E5DD8;
}
/*金额列*/
.gx-od__pay {
  min-width: 140px;
  flex-shrink: 0;
  text-align: left;

}
.gx-od__pay-row {
  margin: 3px 0;
  color: #606266;
  line-height: 1.6;
}
.gx-od-label{
  font-size: 10px;
  color: rgb(153, 153, 153);
}
.gx-od-price{
  font-size: 11px;
  color: rgb(200, 68, 60);
  font-weight: 600;
}
.gx-od-num{
    font-size: 11px;
    color: rgb(26, 26, 46);
}
.gx-od__refund {
  min-width: 200px;
  flex-shrink: 0;
  color: #606266;
  word-break: break-all;
  line-height: 1.6;
}
.gx-od__refund-row {
  margin: 3px 0;
  line-height: 1.6;
}
.gx-od__refund-row span {
  color: #262626;
  font-weight: 500;
}
/*采购单详情*/
.gx-od__purchase {
  min-width: 200px;
  flex-shrink: 0;
}
.gx-od__purchase-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-od__status {
  min-width: 140px;
  flex-shrink: 0;
  text-align: left;
  color: #606266;

  gap: 6px;
}
.gx-od__status p {
  margin: 0;
  line-height: 1.6;
}
.gx-od__status .gx-od__link {
  margin: 0;
}
/* 货品信息列：备注米色卡片 */
.gx-od__remark-box {
  background: #FBF8F2;
  border: 1px solid #F1E8D4;
  border-radius: 6px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.gx-od__remark-line {
  margin: 0;
  font-size: 12px;
  line-height: 1.7;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.gx-od__remark-k {
  color: #909399;
  flex-shrink: 0;
}
.gx-od__remark-val {
  color: #303133;
  word-break: break-all;
}
.gx-od__star {
  margin-left: 4px;
  font-style: normal;
}
.gx-od__refresh {
  cursor: pointer;
  margin-left: 6px;
  color: #909399;
  font-style: normal;
  transition: color .15s ease;
}
.gx-od__refresh:hover {
  color: #C8443C;
}
.gx-od__empty {
  text-align: center;
  padding: 60px 0;
  color: #909399;
  font-size: 13px;
}
.gx-od__empty::before {
  content: '📭';
  display: block;
  font-size: 36px;
  margin-bottom: 8px;
  opacity: .55;
}
.gx-od__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #EBEEF5;
  background: #FAF6EE;
  border-radius: 0 0 10px 10px;
}
.gx-od__pager-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-od__pager-total {
  font-size: 12px;
  color: #666;
}
.gx-od__pager-btns {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.gx-od__page {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E4E7ED;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #606266;
  transition: all .15s ease;
}
.gx-od__page:hover:not(:disabled) {
  border-color: #C8443C;
  color: #C8443C;
}
.gx-od__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-od__page--on {
  background: #C8443C;
  border-color: #C8443C;
  color: #FFFFFF;
  font-weight: 700;
  box-shadow: 0 1px 4px rgba(200, 68, 60, 0.18);
}

.as-countdown {
  margin: 4px 0 0 26px;
  font-size: 12px;
  color: #C8443C;
  line-height: 1.6;
  cursor: pointer;
  font-weight: 500;
  transition: opacity .15s ease;
}
.as-countdown:hover {
  opacity: 0.8;
}
.as-countdown-num {
  color: #C8443C;
  font-weight: 700;
  font-family: 'JetBrains Mono', monospace;
}
.delete-order-confirm__tip {
  margin: 0 0 14px;
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}

.delete-order-confirm__hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}
.delete-order-confirm__hint .red {
  color: #C8443C;
  font-weight: 600;
}
.query_permanent_link {
  color: #1677FF;
  cursor: pointer;
  transition: color .15s ease;
}
.query_permanent_link:hover {
  color: #0E5DD8;
  text-decoration: underline;
}
.combo_flag {
  display: inline-block;
  padding: 1px 6px;
  font-size: 11px;
  color: #C8443C;
  background: linear-gradient(180deg, #FFF1F0 0%, #FFE8E6 100%);
  border: 1px solid #FFCCC7;
  border-radius: 4px;
  font-weight: 500;
}
@media (max-width: 1200px) {
  .gx-od__order-info {
    flex-wrap: wrap;
  }
}
</style>
<style scoped>
.little-hand{
  cursor: pointer;
}

.purchase_order_block {
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 6px;
  background: linear-gradient(180deg, #FFFBEC 0%, #FFF8DF 100%);
  border: 1px solid #F5E2A6;
}
.purchase_order_block.is-fail {
  background: linear-gradient(180deg, #FFF7F7 0%, #FFF1F0 100%);
  border-color: #FFCCC7;
}
.purchase_order_head {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.purchase_order_head .po_label {
  font-size: 12px;
  color: #8C8C8C;
  font-weight: 500;
}
.purchase_order_head .po_order_id {
  font-size: 12px;
  color: #1677FF;
  font-weight: 600;
  font-family: 'JetBrains Mono', monospace;
}
.purchase_order_head .po_order_id:hover {
  color: #0E5DD8;
  text-decoration: underline;
}
.purchase_order_head .po_order_id.muted {
  color: #8C8C8C;
  cursor: default;
}
.purchase_order_head .po_order_id.muted:hover {
  text-decoration: none;
}
.purchase_order_head .line_status_tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  background: linear-gradient(180deg, #FFF7E6 0%, #FFEFD0 100%);
  border: 1px solid #FFD591;
  color: #FA8C16;
  font-weight: 500;
}
.purchase_order_head .line_status_tag .label {
  color: #8C8C8C;
  margin-right: 3px;
}
.purchase_order_head .line_status_tag.st-success,
.purchase_order_head .line_status_tag.st-1 {
  background: linear-gradient(180deg, #F6FFED 0%, #E8F9E0 100%);
  border-color: #B7EB8F;
  color: #52C41A;
}
.purchase_order_head .line_status_tag.st-error,
.purchase_order_head .line_status_tag.st-90,
.purchase_order_head .line_status_tag.st-100 {
  background: linear-gradient(180deg, #FFF1F0 0%, #FFE8E6 100%);
  border-color: #FFCCC7;
  color: #C8443C;
}
.purchase_supplier {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: #303133;
  font-size: 12px;
  margin-bottom: 8px;
}
.purchase_supplier .label {
  color: #909399;
  margin-right: 4px;
}
.purchase_supplier .name {
  color: #303133;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
.purchase_supplier .purchase_icon {
  margin-left: 6px;
  font-size: 14px;
  color: #1677FF;
  cursor: pointer;
  transition: color .15s ease;
}
.purchase_supplier .purchase_icon:hover {
  color: #0E5DD8;
}
.purchase_product_card {
  display: flex;
  padding: 8px;
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  border-radius: 6px;
  margin-bottom: 8px;
  transition: all .15s ease;
}
.purchase_product_card:hover {
  border-color: #FFCCC7;
  box-shadow: 0 1px 4px rgba(200, 68, 60, 0.08);
}
.purchase_product_card .card_img {
  width: 44px;
  height: 44px;
  border-radius: 4px;
  overflow: hidden;
  background: #F5F5F5;
  flex-shrink: 0;
}
.purchase_product_card .card_img.is-link {
  cursor: pointer;
}
.purchase_product_card .card_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.purchase_product_card .card_body {
  flex: 1;
  width: 0;
  margin-left: 8px;
}
.purchase_product_card .card_title_row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin: 0;
}
.purchase_product_card .card_title {
  font-size: 12px;
  color: #303133;
  line-height: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-weight: 500;
}
.purchase_product_card .card_title.is-link {
  cursor: pointer;
  color: #1677FF;
  transition: color .15s ease;
}
.purchase_product_card .card_title.is-link:hover {
  color: #0E5DD8;
}
.purchase_product_card .card_sku,
.purchase_product_card .card_min {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
  white-space: break-spaces;
}
.purchase_product_card .card_fail_msg {
  margin: 4px 0 0;
  font-size: 12px;
  color: #C8443C;
  line-height: 1.4;
  font-weight: 500;
}
.combo_item_card {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #F0F0F0;
}
.combo_item_card:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.combo_item_card.is-fail {
  background: linear-gradient(180deg, #FFF7F7 0%, #FFF1F0 100%);
}
.purchase_order_meta {
  margin-top: 6px;
  font-size: 12px;
  color: #606266;
  line-height: 1.6;
}
.purchase_order_meta p {
  margin: 2px 0;
}
.purchase_order_meta .po_fee {
  margin-left: 12px;
  color: #909399;
}
.purchase_account_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}
.purchase_account_row .account_text {
  flex: 1;
  min-width: 0;
  word-break: break-all;
  font-size: 12px;
  color: #606266;
}
.purchase_account_row .cancel_group_btn {
  flex-shrink: 0;
}
.purchase_empty {
  font-size: 12px;
  color: #909399;
  text-align: center;
  padding: 12px 0;
  background: #FAFAFA;
  border-radius: 6px;
  margin-bottom: 8px;
}
.combo_item_card {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #F0F0F0;
}
.combo_item_card:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.combo_item_card.is-fail {
  background: linear-gradient(180deg, #FFF7F7 0%, #FFF1F0 100%);
}
.purchase_order_meta {
  margin-top: 6px;
  font-size: 12px;
  color: #606266;
  line-height: 1.6;
}
.purchase_order_meta p {
  margin: 2px 0;
}
.purchase_order_meta .po_fee {
  margin-left: 12px;
  color: #909399;
}
.purchase_account_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}
.purchase_account_row .account_text {
  flex: 1;
  min-width: 0;
  word-break: break-all;
  font-size: 12px;
  color: #606266;
}
.purchase_account_row .cancel_group_btn {
  flex-shrink: 0;
}
.purchase_footer {
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 8px;
}
.purchase_footer.is_linked {
  justify-content: space-between;
}
.purchase_footer .return_address_row {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 6px 8px;
  background: #FAFAFA;
  border: 1px solid #F0F0F0;
  border-radius: 6px;
  cursor: pointer;
  transition: all .15s ease;
}
.purchase_footer .return_address_row:hover {
  background: #FFF5F4;
  border-color: #FFCCC7;
}
.purchase_footer .return_address_head {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 5px;
  width: 100%;
  min-width: 0;
  line-height: 16px;
}
.purchase_footer .return_label {
  color: #606266;
  font-size: 12px;
  flex-shrink: 0;
  line-height: 16px;
  font-weight: 500;
}
.purchase_footer .return_status_tag {
  display: inline-block;
  padding: 1px 6px;
  font-size: 11px;
  line-height: 16px;
  border-radius: 4px;
  flex-shrink: 0;
  font-weight: 500;
}
.purchase_footer .return_address_row.is-success .return_status_tag {
  color: #52C41A;
  background: linear-gradient(180deg, #F6FFED 0%, #E8F9E0 100%);
  border: 1px solid #B7EB8F;
}
.purchase_footer .return_address_row.is-processing .return_status_tag {
  color: #1677FF;
  background: linear-gradient(180deg, #E6F7FF 0%, #D6F0FF 100%);
  border: 1px solid #91D5FF;
}
.purchase_footer .return_address_row.is-pending .return_status_tag {
  color: #FA8C16;
  background: linear-gradient(180deg, #FFF7E6 0%, #FFEFD0 100%);
  border: 1px solid #FFD591;
}
.purchase_footer .return_address_row.is-error .return_status_tag {
  color: #C8443C;
  background: linear-gradient(180deg, #FFF1F0 0%, #FFE8E6 100%);
  border: 1px solid #FFCCC7;
}
.purchase_footer .return_edit_icon {
  margin-left: auto;
  font-size: 12px;
  color: #909399;
  flex-shrink: 0;
  line-height: 1;
  transition: color .15s ease;
}
.purchase_footer .return_address_row:hover .return_edit_icon {
  color: #C8443C;
}
.purchase_footer .return_warn_icon {
  font-size: 12px;
  color: #C8443C;
  flex-shrink: 0;
  line-height: 1;
}
.purchase_footer .return_time {
  margin: 0;
  font-size: 10px;
  color: #909399;
  line-height: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.purchase_footer .modify_link_btn {
  padding: 0 8px;
  height: auto !important;
  font-size: 12px;
  flex-shrink: 0;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.baba-order-ids-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.baba-order-ids-list li {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #F0F0F0;
  transition: background-color .15s ease;
}
.baba-order-ids-list li:hover {
  background: #FAFAFA;
}
.baba-order-ids-list li:last-child {
  border-bottom: none;
}
.baba-order-ids-list .order-id-link {
  color: #1677FF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  transition: color .15s ease;
}
.baba-order-ids-list .order-id-link:hover {
  color: #0E5DD8;
  text-decoration: underline;
}
.baba-order-ids-list .iconfont {
  cursor: pointer;
  color: #909399;
  font-size: 14px;
  transition: color .15s ease;
}
.baba-order-ids-list .iconfont:hover {
  color: #C8443C;
}
</style>
